// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath d=%27M2.2 4.5L6 8.2l3.8-3.7%27 fill=%27none%27 stroke=%27%231f1f1f%27 stroke-width=%271.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath d=%27M2.2 4.5L6 8.2l3.8-3.7%27 fill=%27none%27 stroke=%27%23111827%27 stroke-width=%271.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.organic-tabs-dashboard {
  width: 98%;
  margin: 0 auto 10px;
  color: #0d468f;
  font-family: "opensans", sans-serif;
}
.organic-tabs-dashboard__tabs {
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid #d4d4d4;
  gap: 2px;
  margin-bottom: 10px;
}
.organic-tabs-dashboard__tab {
  border: 1px solid #c7c7c7;
  border-bottom: 0;
  background: #ececec;
  color: #4f4f4f;
  padding: 4px 12px;
  font-size: 13px;
  line-height: 1.15;
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease;
}
.organic-tabs-dashboard__tab:hover {
  color: #0d468f;
  background: #ffffff;
}
.organic-tabs-dashboard__tab--active {
  background: #ffffff;
  color: #0d468f;
  font-weight: 600;
}
.organic-tabs-dashboard__section-header {
  border-bottom: 1px solid #d5d5d5;
  margin-bottom: 8px;
}
.organic-tabs-dashboard__section-header h2 {
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 700;
  color: #0d468f;
}
.organic-tabs-dashboard__section-header--followers {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: nowrap;
  margin-bottom: 10px !important;
}
.organic-tabs-dashboard__section-header--followers h2 {
  margin: 0;
  color: #0f172a;
}
.organic-tabs-dashboard__section-header-main {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  margin-bottom: 5px;
}
.organic-tabs-dashboard__section-header-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.organic-tabs-dashboard__section-header-title-row {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}
.organic-tabs-dashboard__section-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.4;
}
.organic-tabs-dashboard__section-header--followers-no-divider {
  border-bottom: 0;
  margin-bottom: 0;
}
.organic-tabs-dashboard__section-header-picker {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  min-width: 0;
}
.organic-tabs-dashboard__error {
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 14px;
  border: 1px solid #fecaca;
  border-radius: 4px;
}
.organic-tabs-dashboard__loading {
  padding: 32px 16px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}
.organic-tabs-dashboard__filters {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #d8dde6;
  margin-bottom: 14px;
}
.organic-tabs-dashboard__filters label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 178px;
}
.organic-tabs-dashboard__filters label:first-child {
  min-width: 320px;
}
.organic-tabs-dashboard__filters span {
  color: #0d468f;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}
.organic-tabs-dashboard__filters select,
.organic-tabs-dashboard__filters input {
  height: 40px;
  border: 1px solid #cfd6e1;
  border-radius: 6px;
  padding: 0 12px;
  background: #ffffff;
  color: #1f1f1f;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.organic-tabs-dashboard__filters select:focus,
.organic-tabs-dashboard__filters input:focus {
  border-color: #2f66ab;
  box-shadow: 0 0 0 2px rgba(47, 102, 171, 0.14);
}
.organic-tabs-dashboard__filters select {
  padding-right: 38px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px 12px;
}
.organic-tabs-dashboard__filters input[type=date] {
  min-width: 176px;
}
.organic-tabs-dashboard__filters--followers {
  justify-content: flex-start;
  padding-bottom: 18px;
  border-bottom: 0;
  margin-bottom: 18px;
}
.organic-tabs-dashboard__range-filter {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-width: 320px;
  max-width: 440px;
  height: 58px;
  padding: 0 16px 0 50px;
  border: 1px solid #ccd6e3;
  border-radius: 16px;
  background: #ffffff;
}
.organic-tabs-dashboard__range-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  width: 18px;
  height: 18px;
  color: #64748b;
  transform: translateY(-50%);
}
.organic-tabs-dashboard__range-icon svg {
  display: block;
  width: 18px;
  height: 18px;
}
.organic-tabs-dashboard__range-filter input {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}
.organic-tabs-dashboard__range-filter input:focus {
  border: 0;
  box-shadow: none;
}
.organic-tabs-dashboard__range-separator {
  color: #64748b;
  font-size: 18px;
  font-weight: 500;
}
.organic-tabs-dashboard__kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}
.organic-tabs-dashboard__bottom {
  display: grid;
  grid-template-columns: 360px minmax(0, 1fr);
  gap: 12px;
  margin-bottom: 10px;
  align-items: stretch;
}
.organic-tabs-dashboard__coming-soon {
  border: 1px solid #cbd9ea;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px;
  color: #5e6a7f;
  font-size: 14px;
}

.organic-tabs-dashboard__tabs {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px;
  border-bottom: 0;
  border-radius: 14px;
  background: #edf1f6;
  margin: 0 0 22px;
}

.organic-tabs-dashboard__tab {
  min-height: 40px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  padding: 8px 18px;
  font-size: 12px;
  font-weight: 600;
  box-shadow: none;
}

.organic-tabs-dashboard__tab--active {
  background: #ffffff;
  color: #111827;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.organic-content-report {
  display: block;
}

.organic-content-report__section-header {
  margin-bottom: 4px;
}

.organic-content-report .dashboard-narrative-panel,
.organic-tabs-dashboard .dashboard-narrative-panel {
  margin-bottom: 14px;
}

.organic-content-report__toolbar-field--caption {
  margin-left: -2px;
}

.organic-content-report__toolbar-field {
  position: relative;
  min-height: 44px;
  display: flex;
  align-items: center;
  align-self: start;
}
.organic-content-report__toolbar-field > select,
.organic-content-report__toolbar-field > input {
  width: 100%;
  height: 44px;
  border: 1px solid #ccd6e3;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 16px 0 50px;
  color: #0f172a;
  font-size: 13px;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
.organic-content-report__toolbar-field > select:focus,
.organic-content-report__toolbar-field > input:focus {
  border-color: #9fb3cd;
  box-shadow: 0 0 0 3px rgba(159, 179, 205, 0.18);
}

.organic-content-report__toolbar-field--caption > .organic-custom-select {
  width: 100%;
}

.organic-content-report__caption-select .organic-custom-select__dropdown {
  width: 100%;
  min-width: 100%;
}

.organic-content-report__toolbar-field--range {
  display: flex;
  align-items: center;
  width: max-content;
}

@media (max-width: 700px) {
  .organic-content-report__toolbar-field--range {
    width: 100%;
  }
}
.organic-content-report__kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.organic-content-report__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 260px;
}

.organic-content-card,
.organic-content-panel {
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: none;
}

.organic-content-card {
  min-height: 122px;
  padding: 18px 20px;
  display: grid;
  grid-template-rows: auto auto;
  align-content: start;
  gap: 12px;
}

.organic-content-card__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
}
.organic-content-card__header > div:first-child {
  position: relative;
}

.organic-content-card__title-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.organic-content-card__title-row h3 {
  margin: 0;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.organic-content-card__title-help-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  z-index: 2;
  isolation: isolate;
}

.organic-content-card__title-help-wrap--end .organic-content-card__definition-tooltip {
  left: auto;
  right: 0;
}

.organic-content-card__title-help {
  width: 14px;
  height: 14px;
  border: 1px solid #c6d3e4;
  border-radius: 50%;
  background: #eef4fb;
  color: #7f93ad;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 700;
  cursor: default;
}

.organic-content-card__definition-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 320px;
  max-width: min(320px, 100vw - 40px);
  border-radius: 12px;
  border: 1px solid #d9e3f2;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(14, 30, 62, 0.16);
  padding: 14px;
  z-index: 5000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-2px);
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
  pointer-events: none;
  overflow-wrap: anywhere;
}

@media (max-width: 900px) {
  .organic-content-card__definition-tooltip {
    left: 0;
    right: auto;
    width: min(320px, 100vw - 40px);
  }
  .organic-content-card__title-help-wrap--end .organic-content-card__definition-tooltip {
    right: 0;
    left: auto;
  }
}
.organic-content-card__title-help-wrap:hover .organic-content-card__definition-tooltip,
.organic-content-card__title-help-wrap:focus-within .organic-content-card__definition-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.organic-content-card__title-help-wrap:hover,
.organic-content-card__title-help-wrap:focus-within {
  z-index: 5000;
}

.organic-content-card__definition-text {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  color: #6a7282;
}

.organic-content-card__definition-formula-box {
  border-radius: 10px;
  background: #e8f0fb;
  border-left: 4px solid #1f5da8;
  padding: 10px 12px 12px;
}

.organic-content-card__definition-formula-title {
  margin: 0 0 4px;
  font-size: 13px;
  line-height: 1;
  color: #6a7282;
  font-weight: 700;
}

.organic-content-card__definition-formula {
  margin: 0;
  font-size: 11px;
  line-height: 1.35;
  color: #6a7282;
  font-weight: 500;
}

.organic-content-card__value {
  font-size: 24px;
  line-height: 1.2;
  color: #0f172a;
  font-weight: 700;
  unicode-bidi: plaintext;
}

.organic-content-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #eef4ff;
  color: #356fb6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.organic-content-card__footer {
  margin-top: 0;
}

.organic-content-card__period {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #667085;
  font-size: 13px;
  font-weight: 500;
  flex-wrap: wrap;
  line-height: 1.5;
}

.organic-content-card__period--unavailable,
.organic-engagement-card__period--unavailable {
  color: #98a2b3;
  font-size: 12px;
}

.organic-content-card__period--unavailable .definition-tooltip__trigger,
.organic-engagement-card__period--unavailable .definition-tooltip__trigger {
  width: 16px;
  height: 16px;
  min-width: 16px;
  font-size: 10px;
}

.organic-content-card__period--unavailable .definition-tooltip__popover,
.organic-engagement-card__period--unavailable .definition-tooltip__popover {
  left: 50%;
  right: auto;
  transform: translateX(-50%) translateY(-2px);
}

.organic-content-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-content-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover,
.organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
  transform: translateX(-50%) translateY(0);
}

.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n+1) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
  left: 0;
  right: auto;
  transform: translateY(-2px);
}

.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
  left: auto;
  right: 0;
  transform: translateY(-2px);
}

.organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n+2) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
  left: auto;
  right: 0;
  transform: translateY(-2px);
}

.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n+1) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n+1) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover,
.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
  transform: translateY(0);
}

.organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n+2) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n+2) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
  transform: translateY(0);
}

.organic-content-report__kpis > .organic-content-card:nth-child(4n+1) .organic-content-card__period--unavailable .definition-tooltip__popover,
.organic-content-report__kpis > .organic-engagement-card:nth-child(4n+1) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
  left: 0;
  right: auto;
  transform: translateY(-2px);
}

.organic-content-report__kpis > .organic-content-card:nth-child(4n+1) .organic-content-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-content-report__kpis > .organic-content-card:nth-child(4n+1) .organic-content-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover,
.organic-content-report__kpis > .organic-engagement-card:nth-child(4n+1) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-content-report__kpis > .organic-engagement-card:nth-child(4n+1) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
  transform: translateY(0);
}

.organic-content-report__kpis > .organic-content-card:nth-child(4n) .organic-content-card__period--unavailable .definition-tooltip__popover,
.organic-content-report__kpis > .organic-engagement-card:nth-child(4n) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
  left: auto;
  right: 0;
  transform: translateY(-2px);
}

.organic-content-report__kpis > .organic-content-card:nth-child(4n) .organic-content-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-content-report__kpis > .organic-content-card:nth-child(4n) .organic-content-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover,
.organic-content-report__kpis > .organic-engagement-card:nth-child(4n) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
.organic-content-report__kpis > .organic-engagement-card:nth-child(4n) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
  transform: translateY(0);
}

@media (max-width: 1200px) {
  .organic-content-report__kpis > .organic-content-card:nth-child(2n+1) .organic-content-card__period--unavailable .definition-tooltip__popover,
  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n+1) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
    left: 0;
    right: auto;
    transform: translateY(-2px);
  }
  .organic-content-report__kpis > .organic-content-card:nth-child(2n+1) .organic-content-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
  .organic-content-report__kpis > .organic-content-card:nth-child(2n+1) .organic-content-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover,
  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n+1) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n+1) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
    transform: translateY(0);
  }
  .organic-content-report__kpis > .organic-content-card:nth-child(2n) .organic-content-card__period--unavailable .definition-tooltip__popover,
  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
    left: auto;
    right: 0;
    transform: translateY(-2px);
  }
  .organic-content-report__kpis > .organic-content-card:nth-child(2n) .organic-content-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
  .organic-content-report__kpis > .organic-content-card:nth-child(2n) .organic-content-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover,
  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
    transform: translateY(0);
  }
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n+1) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
    left: 0;
    right: auto;
    transform: translateY(-2px);
  }
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
    left: auto;
    right: 0;
    transform: translateY(-2px);
  }
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n+2) .organic-engagement-card__period--unavailable .definition-tooltip__popover {
    left: auto;
    right: 0;
    transform: translateY(-2px);
  }
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n+1) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n+1) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover,
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
    transform: translateY(0);
  }
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n+2) .organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,
  .organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n+2) .organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {
    transform: translateY(0);
  }
}
.organic-content-card__change {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  /* See \`.dashboard-kpi-card__change\` — keeps "↘ -13.2%" from rendering as "↘ %13.2-". */
  direction: ltr;
  unicode-bidi: isolate;
}

.organic-content-card__change--positive {
  color: #0f9f60;
}

.organic-content-card__change--negative {
  color: #d92d20;
}

.organic-content-card__change--neutral {
  color: #667085;
}

.organic-content-report__engagement-block {
  display: grid;
  gap: 20px;
  grid-column: 1/-1;
}
.organic-content-report__engagement-block h2 {
  margin: 0;
  color: #000000;
  font-size: 18px;
  font-weight: 700;
}

.organic-content-report__section-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.organic-content-report__engagement-grid {
  position: relative;
  z-index: 10;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 14px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.organic-engagement-card {
  position: relative;
  min-height: 96px;
  padding: 18px 20px;
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: none;
  display: grid;
  align-content: start;
  gap: 10px;
  justify-items: start;
  text-align: left;
}

.organic-engagement-card--dropdown {
  overflow: visible;
}

.organic-engagement-card--dropdown-open {
  z-index: 7000;
}

.organic-engagement-card__label-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}

.organic-engagement-card__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.organic-engagement-card__toggle {
  border: 0;
  padding: 0;
  background: transparent;
  color: #7c8ea5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.organic-engagement-card__value {
  color: #101828;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}

.organic-engagement-card__period {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  min-height: 18px;
  color: #667085;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  flex-wrap: wrap;
}

.organic-engagement-card__change {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-right: 4px;
  font-weight: 700;
}

.organic-engagement-card__change--positive {
  color: #16a34a;
}

.organic-engagement-card__change--negative {
  color: #ef4444;
}

.organic-engagement-card__change--neutral {
  color: #667085;
}

.organic-engagement-card__dropdown {
  position: absolute;
  top: 34px;
  right: 14px;
  min-width: 188px;
  padding: 4px 0;
  border: 1px solid #d8e0ea;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.16);
  display: grid;
  gap: 0;
  z-index: 7001;
  text-align: left;
  overflow: hidden;
}

.organic-engagement-card__dropdown--portal {
  position: fixed;
  top: auto;
  right: auto;
  z-index: 2147483000;
}

.organic-engagement-card__dropdown-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 16px 11px;
  border-bottom: 1px solid #e8edf3;
}
.organic-engagement-card__dropdown-row:last-child {
  border-bottom: 0;
}

.organic-engagement-card__dropdown-metric {
  display: grid;
  gap: 2px;
}

.organic-engagement-card__dropdown-label {
  color: #4b5563;
  font-size: 11px;
  line-height: 1.2;
}

.organic-engagement-card__dropdown-value {
  color: #0f172a;
  font-size: 14px;
  line-height: 1.1;
  font-weight: 700;
}

.organic-engagement-card__dropdown-trend {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-top: 2px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.organic-engagement-card__dropdown-trend--positive {
  color: #16a34a;
}

.organic-engagement-card__dropdown-trend--negative {
  color: #ef4444;
}

.organic-engagement-card__dropdown-trend--neutral {
  color: #667085;
}

.organic-content-report__chart-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
  grid-column: 1/-1;
  margin-top: 10px;
  margin-bottom: 20px;
}

.organic-content-panel {
  position: relative;
  padding: 24px 22px 22px;
  overflow: visible;
  min-height: auto;
  border: 1px solid #e5e7f0;
  border-radius: 20px;
  background: #ffffff;
  transition: transform 0.18s ease, box-shadow 0.18s ease, z-index 0s;
}

.organic-content-panel:hover,
.organic-content-panel:focus-within {
  z-index: 20;
  position: relative;
}

.organic-content-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}
.organic-content-panel__header h3 {
  margin: 0;
  color: #101828;
  font-size: 16px;
  font-weight: 700;
}

.organic-content-panel__title {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  min-width: 0;
  flex: 1 1;
  position: relative;
}
.organic-content-panel__title .organic-content-card__title-help-wrap {
  transform: translateY(-1px);
}

.organic-bars__select-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  min-width: 140px;
  max-width: 200px;
}

.organic-bars__select .organic-custom-select__trigger {
  background: #f8fafc;
  border-color: #d6d9e7;
  color: #0f172a;
  min-height: 44px;
}

.organic-bars__select .organic-custom-select__trigger:hover {
  border-color: #bac4d5;
}

.organic-bars__select .organic-custom-select__dropdown {
  border-color: #d8e1ef;
}

@media (max-width: 700px) {
  .organic-content-panel__header {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .organic-bars__select-wrap {
    max-width: 100%;
    width: 100%;
  }
}
.organic-content-panel__trend-legend {
  display: flex;
  justify-content: center;
  gap: 28px;
  padding-top: 6px;
}

.organic-content-panel__donut {
  position: relative;
  width: min(270px, 100%);
  height: 270px;
  margin: 12px auto 28px;
}

.organic-content-panel__segmented {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border: 1px solid #d7e1ee;
  border-radius: 8px;
  background: #f8fafc;
}

.organic-content-panel__segmented-button {
  min-width: 68px;
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.organic-content-panel__segmented-button--active {
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.organic-content-panel__pie-legend {
  padding-top: 0;
}

.organic-content-panel__pie-legend--centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.organic-content-panel__pie-legend--columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(3, auto);
  grid-auto-flow: column;
  gap: 18px 30px;
}

.organic-content-panel__pie-legend-item {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #667085;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
}

.organic-content-panel__pie-legend--centered .organic-content-panel__pie-legend-item {
  width: 100%;
  max-width: 220px;
}

.organic-content-panel__pie-legend-swatch {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
}

.organic-content-panel__pie-legend-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.organic-content-panel__pie-legend-item strong {
  color: #000;
  font-size: 13px;
  font-weight: 800;
  text-align: right;
  white-space: nowrap;
}

.organic-content-panel__donut {
  position: relative;
}

.organic-content-panel__donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  text-align: center;
}

.organic-content-panel__donut-center-value {
  color: #0f172a;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.1;
}

.organic-content-panel__donut-center-label {
  margin-top: 4px;
  color: #5e6a7d;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.organic-content-panel__trend-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #5f748f;
  font-size: 14px;
  font-weight: 600;
}

.organic-content-panel--trends .organic-content-panel__trends-chart {
  margin-inline: -18px;
  width: calc(100% + 36px);
  max-width: calc(100% + 36px);
}
.organic-content-panel--trends .recharts-responsive-container,
.organic-content-panel--trends .recharts-wrapper {
  overflow: visible;
}

@media (max-width: 900px) {
  .organic-content-panel--trends .organic-content-panel__trends-chart {
    margin-inline: -10px;
    width: calc(100% + 20px);
    max-width: calc(100% + 20px);
  }
}
@media (max-width: 640px) {
  .organic-content-panel--trends .organic-content-panel__trends-chart {
    margin-inline: 0;
    width: 100%;
    max-width: 100%;
  }
}
@media (max-width: 1500px) {
  .organic-content-report__chart-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .organic-content-report__chart-grid > .organic-content-panel:last-child {
    grid-column: 1/-1;
  }
}
.organic-content-panel__trend-legend-swatch {
  --legend-color: #6d28d9;
  width: 22px;
  height: 3px;
  border-radius: 999px;
  background: var(--legend-color);
  position: relative;
  display: inline-block;
}
.organic-content-panel__trend-legend-swatch::after {
  content: "";
  position: absolute;
  inset: 50% auto auto 50%;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  border: 2px solid var(--legend-color);
  background: #ffffff;
  transform: translate(-50%, -50%);
}

.organic-content-panel--table {
  padding-bottom: 20px;
  grid-column: 1/-1;
  overflow: visible;
}

.organic-content-panel--bar {
  display: flex;
  flex-direction: column;
}

.organic-content-panel--bar .organic-content-panel__title {
  display: block;
}

.organic-content-panel--bar .organic-content-panel__title h3 {
  display: inline;
  margin-right: 6px;
}

.organic-content-panel__chart-fill {
  flex: none;
  min-height: 280px;
}

.organic-content-panel--bar .organic-bars__pagination {
  flex-shrink: 0;
  margin-top: 12px;
}

/* Post-level table: one card only — title + tooltip live inside DashboardDataTableCard (no outer organic-content-panel shell). */
.organic-content-report__post-table-block {
  width: 100%;
  margin: 8px 0 20px;
}

.organic-content-report__post-table-block .dashboard-data-table-card .dashboard-data-table-panel__header .organic-content-panel__title h3 {
  margin: 0;
  color: #020617;
  font-size: 14px;
  font-weight: 600;
}

.organic-donut__legend--modern {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding-top: 8px;
}

.organic-post-details--modern {
  border: 0;
  border-radius: 0;
  background: #ffffff;
  overflow: visible;
}

/* Post tables use global dashboard-data-table styles; keep width for wide columns */
.organic-post-details__table.dashboard-data-table.organic-post-details__table--modern {
  min-width: 0;
  width: 100%;
  table-layout: fixed;
}

.organic-post-details__col-post {
  width: 42%;
  min-width: 0;
}

.organic-post-details__col-action {
  width: 164px;
}

.organic-post-details__th-post {
  min-width: 0;
}

.organic-post-details__thumb {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #eef2f7;
  color: #0f172a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.organic-post-details__thumb img,
.organic-post-details__thumb video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.organic-post-details__thumb img.organic-post-details__thumb-fallback {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.organic-post-details__thumb img.organic-post-details__thumb-fallback--facebook {
  transform: scale(1.6);
}

.organic-post-details__post-cell {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.organic-post-details__post-copy {
  min-width: 0;
  width: 100%;
}

.organic-post-details__caption-wrap {
  position: relative;
  display: block;
  margin: 0 0 6px;
}

.organic-post-details__post-copy strong {
  display: block;
  margin: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.organic-post-details__caption-tooltip {
  display: none;
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 500;
  width: 320px;
  max-width: min(320px, 100vw - 40px);
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #d9e3f2;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(14, 30, 62, 0.14);
  font-size: 13px;
  font-weight: 400;
  color: #374151;
  line-height: 1.5;
  white-space: normal;
  overflow-wrap: anywhere;
  pointer-events: none;
}

.organic-post-details__caption-wrap:hover .organic-post-details__caption-tooltip {
  display: block;
}

/* \`left: 0\` above grows the tooltip rightward, which overruns into the sidebar when the
   caption column sits near the RTL layout's trailing (right) edge — anchor from the right
   instead so it grows back into the table. */
[dir=rtl] .organic-post-details__caption-tooltip {
  left: auto;
  right: 0;
}

/* Flip tooltip upward for last 2 rows so it never clips at table bottom */
tr:last-child .organic-post-details__caption-tooltip,
tr:nth-last-child(2) .organic-post-details__caption-tooltip {
  top: auto;
  bottom: calc(100% + 6px);
}

.organic-post-details__tag-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 4px;
  min-width: 0;
  width: 100%;
}

.organic-post-details__mini-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: min(100%, 320px);
  min-height: 21px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  border: 1px solid transparent;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}

.organic-post-details__mini-tag--platform {
  color: #14532d;
  background: #ecfdf3;
  border-color: #a7f3d0;
}

.organic-post-details__mini-tag--type {
  color: #9a3412;
  background: #fff7ed;
  border-color: #fdba74;
}

.organic-post-details__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 18px 12px;
  border-top: 1px solid #eef2f7;
  background: #ffffff;
  color: #64748b;
  font-size: 12px;
  margin-top: 0;
  position: relative;
  z-index: 1;
}

.organic-post-details__action-cell {
  white-space: nowrap;
  text-align: center;
}

.organic-post-details__table-wrap.dashboard-data-table-scroll {
  position: relative;
  overflow-x: auto;
  overflow-y: visible;
}

.organic-post-details__table--modern thead th:last-child,
.organic-post-details__table--modern tbody td:last-child {
  position: sticky;
  right: 0;
  z-index: 3;
  background: #ffffff;
  min-width: 164px;
  padding-left: 22px;
  padding-right: 32px;
}

.organic-post-details__table--modern thead th:last-child {
  box-shadow: -1px 0 0 #e8edf4;
}

.organic-post-details__table--modern tbody td:last-child {
  box-shadow: -1px 0 0 #eef2f7;
}

.organic-post-details__th-tooltip {
  overflow: visible;
}

/**
 * Header cells must all start their label on the same line, whatever the label
 * length. Two-line labels ("LIKES / REACTIONS", "ENGAGEMENT RATE") used to make
 * the sort / (?) icons wrap onto their own row, and \`vertical-align: middle\`
 * then centred each cell's block independently — so short labels floated to the
 * middle of the row while long ones started at the top.
 *
 * Instead: top-align every header cell, keep label + ⇅ + (?) on one flex row,
 * and let only the label text itself wrap under the icons.
 */
.organic-post-details--modern .organic-post-details__table.dashboard-data-table thead th {
  vertical-align: top;
  line-height: 16px;
}

.organic-post-details__th-tooltip .dashboard-data-table__th-help-row,
.organic-post-details__th-tooltip .dashboard-data-table__sort {
  flex-wrap: nowrap;
  align-items: flex-start;
  column-gap: 6px;
  line-height: 16px;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: start;
}

.organic-post-details__th-tooltip .dashboard-data-table__sort > svg {
  margin-top: 1px;
}

.organic-post-details__th-tooltip:has(.definition-tooltip:hover),
.organic-post-details__th-tooltip:has(.definition-tooltip:focus-within) {
  z-index: 20;
}

.organic-post-details__action-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  min-width: 86px;
  height: 34px;
  padding: 0 16px;
  border: 1px solid #2c68ad;
  border-radius: 8px;
  background: #2c68ad;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
  text-decoration: none;
}

.organic-post-details__action-button:hover {
  background: #1d4ed8;
  color: #fff;
  border-color: #1d4ed8;
}

.organic-post-details__action-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.organic-post-details__table-toolbar {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: auto;
  min-width: 0;
}

.organic-post-details__table-toolbar .dashboard-data-table-panel__search {
  min-width: 320px;
  width: min(42vw, 500px);
  height: 44px;
  flex: 0 1 500px;
}

.organic-post-details__export-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 44px;
  padding: 0 12px;
  border: 1px solid #d7e1ee;
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.organic-post-details__export-button:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #bfd3ea;
}

.organic-post-details__export-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .organic-post-details__table-toolbar {
    width: 100%;
    flex-wrap: wrap;
  }
  .organic-post-details__table-toolbar .dashboard-data-table-panel__search {
    min-width: 0;
    width: 100%;
    flex: 1 1;
  }
}
.organic-bars__value-label {
  fill: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

.organic-bars__pagination {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 12px;
  padding: 8px 0 4px;
}

.organic-bars__pagination button {
  width: 36px;
  height: 36px;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  background: #f8fafc;
  color: #0f172a;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
}

.organic-bars__pagination button:hover:not(:disabled) {
  background: #eef2f7;
}

.organic-bars__pagination button:disabled {
  opacity: 0.35;
  background: #f3f4f6;
  cursor: not-allowed;
}

.organic-bars__pagination span {
  color: #475569;
  font-size: 13px;
  font-weight: 500;
}

.organic-post-details--modern .organic-post-details__table-wrap {
  max-height: none;
  overflow-x: auto;
  overflow-y: visible;
}

.organic-post-details__pagination {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.organic-post-details__pagination button {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #ffffff;
  color: #475569;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: opacity 0.16s ease, color 0.16s ease, background-color 0.16s ease, border-color 0.16s ease;
}

.organic-post-details__pagination button:hover:not(:disabled) {
  background: #f8fafc;
}

.organic-post-details__pagination button:disabled {
  opacity: 0.35;
  color: #94a3b8;
  cursor: not-allowed;
}

.organic-followers__fb-icon {
  width: 38px;
  height: 38px;
  margin-bottom: 5px;
  border-radius: 50%;
  background: #0d468f;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.organic-followers__fb-icon svg {
  width: 28px;
  height: 28px;
  display: block;
}

.organic-followers__ig-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: none;
  color: #0d468f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.organic-followers-layout {
  display: grid;
  grid-template-columns: 340px minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
  align-items: stretch;
}

.organic-followers-trend {
  grid-column: 1/-1;
  min-height: 360px;
}
.organic-followers-trend .recharts-surface {
  direction: ltr;
}
.organic-followers-trend__toggle {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border: 1px solid #dbe4f0;
  border-radius: 8px;
  background: #f8fafc;
}
.organic-followers-trend__toggle-button {
  min-width: 74px;
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #5f748f;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}
.organic-followers-trend__toggle-button:hover {
  color: #0d468f;
}
.organic-followers-trend__toggle-button--active {
  background: #0d468f;
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(13, 70, 143, 0.2);
}
.organic-followers-trend__toggle-button--active:hover {
  color: #ffffff;
}
.organic-followers-trend__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  color: #8a9bb8;
  font-size: 14px;
  font-weight: 600;
}

.organic-followers-layout__kpis {
  display: grid;
  grid-template-rows: auto auto;
  gap: 10px;
  align-content: start;
  align-self: start;
}

.organic-instagram-layout {
  display: grid;
  grid-template-columns: 520px minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
  align-items: stretch;
}

.organic-instagram-layout__left {
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 14px;
}

.organic-instagram-layout__kpis {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.organic-followers-kpi {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: none;
  padding: 18px 20px;
  background: #ffffff;
  min-height: 188px;
  position: relative;
}
.organic-followers-kpi h3 {
  margin: 0;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: left;
}
.organic-followers-kpi .organic-content-panel__title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  margin-block: 0 6px;
  margin-inline: 0 72px;
}
.organic-followers-kpi .organic-content-panel__title h3 {
  margin: 0;
  text-align: left;
  line-height: 1.2;
}
.organic-followers-kpi__badge {
  position: absolute;
  inset-inline-end: 20px;
  top: 18px;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #f8fafc;
  color: #356fb6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
}
.organic-followers-kpi__content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 92px;
  align-items: center;
  min-height: 96px;
  gap: 10px;
}
.organic-followers-kpi__meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 0;
  padding: 0;
  min-width: 0;
}
.organic-followers-kpi__value {
  font-size: 24px;
  line-height: 1.2;
  color: #101828;
  font-weight: 700;
  margin-bottom: 8px;
}
.organic-followers-kpi__period {
  font-size: 12px;
  color: #667085;
  margin: 0;
  line-height: 1.5;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  font-weight: 500;
}
.organic-followers-kpi__period--unavailable {
  color: #8a94a6;
}
.organic-followers-kpi__period--unavailable .definition-tooltip__trigger {
  color: inherit;
}
.organic-followers-kpi__change {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-weight: 600;
}
.organic-followers-kpi__change--positive {
  color: #0d8a3e;
}
.organic-followers-kpi__change--negative {
  color: #c0392b;
}
.organic-followers-kpi__change--neutral {
  color: #64748b;
}
.organic-followers-kpi__chart {
  height: 74px;
  align-self: center;
  width: 100%;
}

.organic-followers-layout .organic-followers-kpi {
  min-height: 172px;
  height: 172px;
  padding: 18px 20px;
}
.organic-followers-layout .organic-followers-kpi .organic-content-panel__title {
  margin: 0 60px 6px 0;
}
.organic-followers-layout .organic-followers-kpi .organic-followers-kpi__content {
  min-height: 92px;
  grid-template-columns: minmax(0, 1fr) 88px;
}
.organic-followers-layout .organic-followers-kpi .organic-followers-kpi__meta {
  padding: 0;
}
.organic-followers-layout .organic-followers-kpi .organic-followers-kpi__chart {
  height: 70px;
}

.organic-followers-kpi--instagram {
  min-height: 188px;
}

.organic-instagram-gender {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: none;
  padding: 12px 10px 12px;
  background: #ffffff;
  position: relative;
}
.organic-instagram-gender h3 {
  margin: 0 0 8px;
  color: #0d468f;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}
.organic-instagram-gender .organic-content-panel__title {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 0 8px;
}
.organic-instagram-gender .organic-content-panel__title h3 {
  margin: 0;
  line-height: 1.2;
  text-align: left;
}
.organic-instagram-gender .organic-content-panel__title .organic-content-card__title-help-wrap {
  transform: translateY(0);
}
.organic-instagram-gender__content {
  display: grid;
  gap: 12px;
}
.organic-instagram-gender__group {
  display: grid;
  grid-template-columns: 170px minmax(0, 1fr);
  gap: 12px;
  padding: 2px 6px;
}
.organic-instagram-gender__summary {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  grid-template-rows: auto auto;
  column-gap: 30px;
  row-gap: 0;
  align-items: center;
  justify-items: start;
  align-content: center;
}
.organic-instagram-gender__icon {
  color: #0d4f9d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  grid-column: 1;
  grid-row: 1/span 2;
}
.organic-instagram-gender__icon svg {
  width: 26px;
  height: 26px;
  display: block;
}
.organic-instagram-gender__percent {
  color: #0d4f9d;
  font-size: 20px;
  line-height: 1;
  font-weight: 700;
  grid-column: 2;
  grid-row: 1;
  margin: 0;
}
.organic-instagram-gender__period {
  color: #325d88;
  font-size: 12px;
  line-height: 1.05;
  grid-column: 2;
  grid-row: 2;
  margin: 0;
  transform: translateY(-2px);
}
.organic-instagram-gender__ages {
  display: grid;
  gap: 1px;
}
.organic-instagram-gender__age-row {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  min-height: 18px;
  --followers-bar-color: #2b74e4;
}
.organic-instagram-gender__age-row:nth-child(7n+2) {
  --followers-bar-color: #94d0b5;
}
.organic-instagram-gender__age-row:nth-child(7n+3) {
  --followers-bar-color: #f6c15f;
}
.organic-instagram-gender__age-row:nth-child(7n+4) {
  --followers-bar-color: #8d4fd3;
}
.organic-instagram-gender__age-row:nth-child(7n+5) {
  --followers-bar-color: #5d97ee;
}
.organic-instagram-gender__age-row:nth-child(7n+6) {
  --followers-bar-color: #5abf8b;
}
.organic-instagram-gender__age-row:nth-child(7n) {
  --followers-bar-color: #f0a84a;
}
.organic-instagram-gender__age-label {
  color: #5f6470;
  font-size: 12px;
  line-height: 1.05;
  white-space: nowrap;
}
.organic-instagram-gender__bar-track {
  position: relative;
  height: 10px;
  background: transparent;
}
.organic-instagram-gender__bar-fill {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  background: var(--followers-bar-color);
  display: block;
}
.organic-instagram-gender__bar-fill::after {
  content: "";
  position: absolute;
  right: -3px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--followers-bar-color);
}
.organic-instagram-gender__tooltip {
  position: absolute;
  right: 8px;
  left: auto;
  max-width: 250px;
  z-index: 10;
}

.organic-followers-map {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: none;
  padding: 12px 10px 10px;
  background: #ffffff;
  display: grid;
  grid-template-rows: auto 320px auto;
  align-content: start;
  min-height: 542px;
}
.organic-followers-map h3 {
  margin: 0 0 8px;
  color: #0d468f;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}
.organic-followers-map .organic-content-panel__title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}
.organic-followers-map .organic-content-panel__title h3 {
  margin: 0;
  line-height: 1.2;
}
.organic-followers-map__canvas {
  border: 1px solid #e5e8ee;
  background: #fafbfc;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8993a1;
  font-size: 12px;
}
.organic-followers-map__footer {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 8px;
  position: relative;
}
.organic-followers-map__footer label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  width: 110px;
}
.organic-followers-map__footer label span {
  color: #0d468f;
  font-size: 10px;
  font-weight: 700;
}
.organic-followers-map__footer label input {
  width: 94px;
  height: 22px;
  border: 1px solid #757575;
  padding: 0 6px;
  font-size: 12px;
}
.organic-followers-map__footer ul {
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid #eceff4;
  width: 100%;
}
.organic-followers-map__footer li {
  font-size: 12px;
  color: #4e5865;
  padding: 7px 8px;
  border-bottom: 1px solid #f0f2f6;
}
.organic-followers-map__count-control {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 110px;
}
.organic-followers-map__range {
  width: 96px;
  height: 12px;
  margin: 0;
  accent-color: #b9bec7;
}
.organic-followers-map__range--all {
  accent-color: #3f3f46;
}
.organic-followers-map__change--up {
  color: #15803d;
  font-size: 11px;
  margin-left: 6px;
}
.organic-followers-map__change--down {
  color: #b91c1c;
  font-size: 11px;
  margin-left: 6px;
}
.organic-followers-map__ranked {
  max-height: none !important;
  overflow: visible !important;
}
.organic-followers-map__ranked li {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  cursor: default;
  --followers-bar-color: #2b74e4;
}
.organic-followers-map__ranked li:nth-child(7n+2) {
  --followers-bar-color: #94d0b5;
}
.organic-followers-map__ranked li:nth-child(7n+3) {
  --followers-bar-color: #f6c15f;
}
.organic-followers-map__ranked li:nth-child(7n+4) {
  --followers-bar-color: #8d4fd3;
}
.organic-followers-map__ranked li:nth-child(7n+5) {
  --followers-bar-color: #5d97ee;
}
.organic-followers-map__ranked li:nth-child(7n+6) {
  --followers-bar-color: #5abf8b;
}
.organic-followers-map__ranked li:nth-child(7n) {
  --followers-bar-color: #f0a84a;
}
.organic-followers-map__ranked li p {
  margin: 0;
  font-size: 12px;
  color: #3b4654;
  line-height: 1.2;
}
.organic-followers-map__rank-metric {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 4px;
}
.organic-followers-map__rank-metric > span:first-of-type {
  display: block;
  height: 10px;
  background: var(--followers-bar-color);
  min-width: 2px;
}
.organic-followers-map__rank-metric strong {
  font-size: 12px;
  color: #2f2f2f;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}
.organic-followers-map__rank-metric .organic-followers-map__change--up,
.organic-followers-map__rank-metric .organic-followers-map__change--down {
  margin-left: 2px;
}
.organic-followers-map__tooltip {
  position: absolute;
  right: 6px;
  left: auto;
  max-width: 250px;
  z-index: 12;
  pointer-events: none;
}

.organic-instagram-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  align-items: stretch;
}

.organic-instagram-layout__top {
  display: grid;
  grid-template-columns: 360px minmax(0, 1fr);
  gap: 24px;
  align-items: stretch;
}

.organic-instagram-layout__kpis {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

.organic-instagram-layout .organic-followers-kpi--instagram {
  min-height: 150px;
  height: 150px;
  padding: 24px 28px;
  border-color: #dbe4f0;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.organic-instagram-layout .organic-followers-kpi--instagram .organic-content-panel__title {
  margin-block: 0 4px;
  margin-inline: 0 74px;
}
.organic-instagram-layout .organic-followers-kpi--instagram .organic-followers-kpi__badge {
  top: 24px;
  inset-inline-end: 28px;
  width: 52px;
  height: 52px;
  border-radius: 10px;
  background: #eef4fb;
  color: #2e6fb9;
}
.organic-instagram-layout .organic-followers-kpi--instagram .organic-followers-kpi__content {
  display: block;
  min-height: 0;
}
.organic-instagram-layout .organic-followers-kpi--instagram .organic-followers-kpi__value {
  font-size: 30px;
  line-height: 1.05;
  margin-bottom: 22px;
}
.organic-instagram-layout .organic-followers-kpi--instagram .organic-followers-kpi__period {
  font-size: 14px;
  color: #8ba0bb;
}

.organic-followers-trend--instagram {
  grid-column: auto;
  min-height: 326px;
  padding: 28px 30px 16px;
  border-color: #dbe4f0;
  border-radius: 14px;
}
.organic-followers-trend--instagram .organic-content-panel__header {
  margin-bottom: 10px;
}
.organic-followers-trend--instagram .organic-content-panel__title h3 {
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  text-align: left;
}
.organic-followers-trend--instagram .organic-followers-trend__toggle {
  border: 0;
  border-radius: 10px;
  background: #f0f5fb;
  padding: 4px;
}
.organic-followers-trend--instagram .organic-followers-trend__toggle-button {
  min-width: 70px;
  height: 32px;
  border-radius: 8px;
  color: #6b7f98;
  font-size: 12px;
}
.organic-followers-trend--instagram .organic-followers-trend__toggle-button--active {
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.08);
}

.organic-instagram-gender {
  padding: 28px 34px 36px;
  border-color: #dbe4f0;
  border-radius: 14px;
}
.organic-instagram-gender .organic-content-panel__title {
  justify-content: flex-start;
  margin: 0 0 22px;
}
.organic-instagram-gender .organic-content-panel__title h3 {
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  text-align: left;
}
.organic-instagram-gender__content {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
.organic-instagram-gender__group {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  min-height: 430px;
  padding: 22px 26px 20px;
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  background: #ffffff;
}
.organic-instagram-gender__summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  text-align: center;
}
.organic-instagram-gender__summary h4 {
  margin: 0;
  color: #111827;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}
.organic-instagram-gender__percent {
  color: #2f6fb8;
  font-size: 28px;
  line-height: 1;
  font-weight: 800;
  margin: 0;
}
.organic-instagram-gender__period {
  color: #8ba0bb;
  font-size: 14px;
  line-height: 1.2;
  transform: none;
}
.organic-instagram-gender__donut {
  width: 220px;
  max-width: 100%;
  height: 180px;
  margin: 0 auto;
}
.organic-instagram-gender__legend {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 26px;
  row-gap: 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.organic-instagram-gender__legend li {
  display: grid;
  grid-template-columns: 14px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  min-width: 0;
}
.organic-instagram-gender__legend span:not(.organic-instagram-gender__legend-swatch) {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.organic-instagram-gender__legend strong {
  color: #475569;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
}
.organic-instagram-gender__legend-swatch {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  display: inline-block;
}

.organic-instagram-layout__geo {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.organic-instagram-ranked {
  min-height: 540px;
  padding: 34px 34px 38px;
  border-color: #dbe4f0;
  border-radius: 14px;
}
.organic-instagram-ranked__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 34px;
}
.organic-instagram-ranked .organic-content-panel__title {
  justify-content: flex-start;
  margin: 0;
}
.organic-instagram-ranked .organic-content-panel__title h3 {
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  text-align: left;
}
.organic-instagram-ranked .organic-content-panel__title .definition-tooltip__trigger {
  transform: translateY(0);
}
.organic-instagram-ranked__control {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  color: #111827;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
.organic-instagram-ranked__control select {
  width: 86px;
  height: 44px;
  border: 1px solid #cbd9ea;
  border-radius: 10px;
  background: #ffffff;
  color: #111827;
  padding: 0 32px 0 16px;
  font-size: 16px;
  font-weight: 500;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px 12px;
}
.organic-instagram-ranked__list {
  display: grid;
  gap: 18px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.organic-instagram-ranked__item {
  display: grid;
  grid-template-columns: 164px minmax(0, 1fr) 72px;
  align-items: center;
  gap: 12px;
  min-height: 20px;
}
.organic-instagram-ranked__item strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
  text-align: right;
  white-space: nowrap;
}
.organic-instagram-ranked__name {
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.organic-instagram-ranked__bar-track {
  display: block;
  height: 18px;
  border-radius: 4px;
  background: #f0f5fb;
  overflow: hidden;
}
.organic-instagram-ranked__bar-fill {
  display: block;
  height: 100%;
  border-radius: 4px;
}
.organic-instagram-ranked__empty {
  display: flex;
  min-height: 320px;
  align-items: center;
  justify-content: center;
  color: #8ba0bb;
  font-size: 14px;
  font-weight: 700;
}
.organic-instagram-ranked__tooltip {
  position: fixed;
  z-index: 40;
  max-width: 260px;
  pointer-events: none;
}

.organic-facebook-followers-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  align-items: stretch;
}

.organic-facebook-followers-layout__top {
  display: grid;
  grid-template-columns: 360px minmax(0, 1fr);
  gap: 24px;
  align-items: stretch;
}

.organic-facebook-followers-layout__kpis {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

.organic-facebook-followers-layout .organic-followers-kpi--facebook-modern {
  min-height: 150px;
  height: 150px;
  padding: 24px 28px;
  border-color: #dbe4f0;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.organic-facebook-followers-layout .organic-followers-kpi--facebook-modern .organic-content-panel__title {
  margin-block: 0 4px;
  margin-inline: 0 74px;
}
.organic-facebook-followers-layout .organic-followers-kpi--facebook-modern .organic-followers-kpi__badge {
  top: 24px;
  inset-inline-end: 28px;
  width: 52px;
  height: 52px;
  border-radius: 10px;
  background: #eef4fb;
  color: #2e6fb9;
}
.organic-facebook-followers-layout .organic-followers-kpi--facebook-modern .organic-followers-kpi__content {
  display: block;
  min-height: 0;
}
.organic-facebook-followers-layout .organic-followers-kpi--facebook-modern .organic-followers-kpi__value {
  font-size: 30px;
  line-height: 1.05;
  margin-bottom: 22px;
}
.organic-facebook-followers-layout .organic-followers-kpi--facebook-modern .organic-followers-kpi__period {
  font-size: 14px;
  color: #8ba0bb;
}

.organic-followers-trend--modern {
  grid-column: auto;
  min-height: 326px;
  padding: 28px 30px 16px;
  border-color: #dbe4f0;
  border-radius: 14px;
}
.organic-followers-trend--modern .organic-content-panel__header {
  margin-bottom: 10px;
}
.organic-followers-trend--modern .organic-content-panel__title h3 {
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  text-align: left;
}
.organic-followers-trend--modern .organic-followers-trend__toggle {
  border: 0;
  border-radius: 10px;
  background: #f0f5fb;
  padding: 4px;
}
.organic-followers-trend--modern .organic-followers-trend__toggle-button {
  min-width: 70px;
  height: 32px;
  border-radius: 8px;
  color: #6b7f98;
  font-size: 12px;
}
.organic-followers-trend--modern .organic-followers-trend__toggle-button--active {
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.08);
}

.organic-facebook-followers-layout__geo {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.organic-followers-ranked {
  min-height: 540px;
  padding: 34px 34px 38px;
  border-color: #dbe4f0;
  border-radius: 14px;
}
.organic-followers-ranked__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 34px;
}
.organic-followers-ranked .organic-content-panel__title {
  justify-content: flex-start;
  margin: 0;
}
.organic-followers-ranked .organic-content-panel__title h3 {
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  text-align: left;
}
.organic-followers-ranked .organic-content-panel__title .definition-tooltip__trigger {
  transform: translateY(0);
}
.organic-followers-ranked__control {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  color: #111827;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
.organic-followers-ranked__control select {
  width: 86px;
  height: 44px;
  border: 1px solid #cbd9ea;
  border-radius: 10px;
  background: #ffffff;
  color: #111827;
  padding: 0 32px 0 16px;
  font-size: 16px;
  font-weight: 500;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px 12px;
}
.organic-followers-ranked__list {
  display: grid;
  gap: 18px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.organic-followers-ranked__item {
  display: grid;
  grid-template-columns: 164px minmax(0, 1fr) 72px;
  align-items: center;
  gap: 12px;
  min-height: 20px;
}
.organic-followers-ranked__item strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
  text-align: right;
  white-space: nowrap;
}
.organic-followers-ranked__name {
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.organic-followers-ranked__bar-track {
  display: block;
  height: 18px;
  border-radius: 4px;
  background: #f0f5fb;
  overflow: hidden;
}
.organic-followers-ranked__bar-fill {
  display: block;
  height: 100%;
  border-radius: 4px;
}
.organic-followers-ranked__empty {
  display: flex;
  min-height: 320px;
  align-items: center;
  justify-content: center;
  color: #8ba0bb;
  font-size: 14px;
  font-weight: 700;
}
.organic-followers-ranked__tooltip {
  position: fixed;
  z-index: 40;
  max-width: 260px;
  pointer-events: none;
}

.organic-kpi-card {
  border: 1px solid #c5d8ee;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  padding: 10px 10px 8px;
  background: #ffffff;
  min-height: 172px;
}
.organic-kpi-card h3 {
  margin: 0 0 6px;
  color: #0d468f;
  font-size: 14px;
  font-weight: 700;
  margin-top: 20px;
}
.organic-kpi-card__content {
  display: grid;
  grid-template-columns: 45% 55%;
  align-items: end;
  min-height: 138px;
  gap: 4px;
}
.organic-kpi-card__meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 106px;
  padding: 0 8px 10px 26px;
}
.organic-kpi-card__value {
  font-size: 20px;
  line-height: 1;
  color: #124a94;
  font-weight: bolder;
  margin-bottom: 4px;
}
.organic-kpi-card__period {
  font-size: 10px;
  color: #325d88;
  margin-bottom: 0;
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.organic-kpi-card__change {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-weight: 600;
}
.organic-kpi-card__change--positive {
  color: #0d8a3e;
}
.organic-kpi-card__change--negative {
  color: #c0392b;
}
.organic-kpi-card__chart {
  height: 100px;
  align-self: end;
}
.organic-kpi-card__chart .recharts-wrapper,
.organic-kpi-card__chart .recharts-surface,
.organic-kpi-card__chart .recharts-responsive-container {
  overflow: visible !important;
}

.organic-engagements {
  border: 1px solid #bfd4eb;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
  max-width: 360px;
  height: 100%;
}
.organic-engagements h3 {
  margin: 0;
  padding: 10px 12px;
  text-align: center;
  color: #0d468f;
  font-size: 14px;
  font-weight: 700;
  border-bottom: 1px solid #d6d9de;
}
.organic-engagements__rows {
  position: relative;
  padding-bottom: 10px;
}
.organic-engagements__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  min-height: 40px;
  padding: 6px 16px;
  font-size: 12px;
  color: #2f2f2f;
  cursor: default;
}
.organic-engagements__row span {
  text-align: center;
  padding: 0 8px;
}
.organic-engagements__row strong {
  color: #4d4d4d;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  min-width: 70px;
  text-align: right;
}
.organic-engagements__row--alt {
  background: #edf0f6;
}
.organic-engagements__tooltip {
  position: absolute;
  right: 12px;
  top: 46px;
  z-index: 10;
}

.organic-visuals {
  border: 1px solid #bfd4eb;
  border-radius: 10px;
  background: #ffffff;
  padding: 10px 12px;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
  gap: 16px;
}

.organic-donut__header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2px;
}
.organic-donut__header h3 {
  margin: 0;
  color: #0d468f;
  font-size: 14px;
  font-weight: 700;
}
.organic-donut__title-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.organic-donut__toggle {
  width: auto;
  height: auto;
  border: 0;
  background: transparent;
  color: #2f66ab;
  cursor: pointer;
  padding: 1px 0 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.organic-donut__toggle:focus {
  outline: none;
}
.organic-donut__toggle-icon {
  display: inline-block;
  width: 11px;
  height: 11px;
  border-right: 2px solid #2f66ab;
  border-top: 2px solid #2f66ab;
  transform: rotate(45deg);
  transition: transform 0.2s ease;
}
.organic-donut__toggle--reverse .organic-donut__toggle-icon {
  transform: rotate(-135deg);
}
.organic-donut__legend {
  list-style: none;
  margin: 0;
  padding: 6px 0 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px 10px;
}
.organic-donut__legend li {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.organic-donut__legend span {
  width: 9px;
  height: 9px;
  border-radius: 1px;
  flex-shrink: 0;
}
.organic-donut__legend p {
  margin: 0;
  font-size: 12px;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.organic-donut .recharts-wrapper {
  margin-top: 2px;
}

.organic-bars__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.organic-bars__header h3 {
  margin: 0;
  color: #0d468f;
  font-size: 14px;
  font-weight: 700;
}
.organic-bars__select-wrap {
  position: relative;
  width: 184px;
}
.organic-bars__select {
  width: 100%;
}
.organic-bars .recharts-cartesian-axis-line,
.organic-bars .recharts-cartesian-axis-tick-line {
  stroke: transparent;
}
.organic-bars__pagination {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-top: 8px;
  color: #64748b;
  font-size: 12px;
}
.organic-bars__pagination button {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #ffffff;
  color: #475569;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: opacity 0.16s ease, color 0.16s ease, background-color 0.16s ease, border-color 0.16s ease;
}
.organic-bars__pagination button:hover:not(:disabled) {
  background: #f8fafc;
}
.organic-bars__pagination button:disabled {
  opacity: 0.35;
  color: #94a3b8;
  cursor: not-allowed;
}

.organic-custom-select {
  position: relative;
  width: 100%;
}

.organic-custom-select__trigger {
  width: 100%;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px;
  border: 1px solid #ccd6e3;
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.organic-custom-select__trigger:hover {
  border-color: #c7d1df;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.organic-custom-select__trigger--open {
  border-color: #cfd8e3;
  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18);
}

.organic-custom-select__trigger-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.organic-custom-select__trigger-icon {
  width: 16px;
  height: 16px;
  color: #6b7280;
  flex-shrink: 0;
}

.organic-custom-select__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 30;
  width: 100%;
  max-height: 420px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid #e6edf7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.organic-custom-select__option {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.organic-custom-select__option:hover {
  background: #f2f2f2;
}

.organic-custom-select__option--active {
  background: #e4e4e4;
  color: #1f1f1f;
  font-weight: 600;
}

.organic-custom-select__option-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #111827;
}

.organic-custom-select__option-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.organic-post-details {
  border: none;
  border-radius: 10px;
  background: #ffffff;
  overflow: hidden;
}
.organic-post-details__header {
  border-bottom: 1px solid #d6d9de;
  padding: 8px 12px;
  text-align: center;
}
.organic-post-details__header h3 {
  margin: 0;
  color: #0d468f;
  font-size: 14px;
  font-weight: 700;
}
.organic-post-details__table-wrap {
  overflow-x: auto;
  max-height: 420px;
  overflow-y: auto;
}
.organic-post-details__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 1260px;
  table-layout: fixed;
}
.organic-post-details__table th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #ffffff;
  color: #4b4f58;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 8px;
  text-align: left;
  border-bottom: 1px solid #e3e7ed;
  white-space: nowrap;
  box-sizing: border-box;
}
.organic-post-details__table td {
  padding: 20px 20px;
  font-size: 14px;
  line-height: 1.35;
  color: #0f172a;
  vertical-align: middle;
  background: #ffffff;
  text-align: left;
}
.organic-post-details__table tr:nth-child(even) td {
  background: #ffffff;
}
.organic-post-details__col-caption {
  width: 28%;
}
.organic-post-details__col-post-type {
  width: 9%;
}
.organic-post-details__col-engagement {
  width: 10%;
}
.organic-post-details__col-metric {
  width: 8.83%;
}
.organic-post-details__caption {
  text-align: left !important;
  line-height: 1.25;
  color: #5f6470 !important;
  border-right: 1px solid #e3e7ed;
}
.organic-post-details__post-type {
  text-align: left;
  border-right: 1px solid #e3e7ed;
}
.organic-post-details__type-text {
  color: #616877;
  font-size: 13px;
  line-height: 1.2;
}
.organic-post-details__th-caption {
  text-align: left !important;
  padding-left: 8px !important;
  border-right: 1px solid #e3e7ed;
}
.organic-post-details__th-post-type, .organic-post-details__th-engagement {
  text-align: left !important;
}
.organic-post-details__th-label {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
}
.organic-post-details__header-icon {
  display: inline-flex;
  align-items: center;
  color: #5f6470;
  line-height: 1;
}
.organic-post-details__th-label--sortable {
  cursor: pointer;
  transition: color 0.16s ease;
}
.organic-post-details__th-label--sortable:hover {
  color: #0d468f;
}
.organic-post-details__th-label--active {
  color: #0d468f;
}
.organic-post-details__sort-icon {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: #6d7788;
  transform: translateY(-1px);
  transition: color 0.16s ease;
}
.organic-post-details__sort-icon--active {
  color: #0d468f;
}
.organic-post-details__sort-bars {
  display: inline-flex;
  flex-direction: column;
  gap: 1px;
}
.organic-post-details__sort-bars i {
  display: block;
  height: 1px;
  background: #6d7788;
  width: 8px;
}
.organic-post-details__sort-bars i:nth-child(2) {
  width: 6px;
}
.organic-post-details__sort-bars i:nth-child(3) {
  width: 4px;
}
.organic-post-details__sort-icon--desc .organic-post-details__sort-bars i:nth-child(1) {
  width: 4px;
}
.organic-post-details__sort-icon--desc .organic-post-details__sort-bars i:nth-child(2) {
  width: 6px;
}
.organic-post-details__sort-icon--desc .organic-post-details__sort-bars i:nth-child(3) {
  width: 8px;
}
.organic-post-details__pill {
  display: inline-grid;
  place-items: center;
  align-items: center;
  justify-content: center;
  min-width: 68px;
  min-height: 40px;
  padding: 0 10px;
  border-radius: 14px;
  background: #0e4f9a;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}
.organic-post-details__pill--secondary {
  background: #2f6eb9;
}
.organic-post-details__metric {
  display: inline-grid;
  place-items: center;
  align-items: center;
  justify-content: center;
  min-width: 68px;
  min-height: 40px;
  padding: 0 10px;
  border-radius: 14px;
  background: #f1f2f4;
  color: #2f2f2f;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}
.organic-post-details__metric--blue {
  background: #6e97c9;
  color: #ffffff;
}

/* Force the post-level modern table to use the shared paid-media table mechanics, not the legacy organic table shell above. */
.organic-post-details--modern .organic-post-details__table.dashboard-data-table {
  min-width: fit-content;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
}

.organic-post-details--modern .organic-post-details__col-post {
  width: 320px;
}

.organic-post-details--modern .organic-post-details__col-metric {
  width: 152px;
}

.organic-post-details--modern .organic-post-details__table.dashboard-data-table th {
  padding: 21px 20px;
  border-bottom: 1px solid #e8edf4;
  background: #ffffff;
}

.organic-post-details--modern .organic-post-details__table.dashboard-data-table th.organic-post-details__th-tooltip {
  padding-left: 12px;
  padding-right: 12px;
}

.organic-post-details--modern .organic-post-details__table.dashboard-data-table td {
  padding: 20px 20px;
}

.organic-post-details--modern .organic-post-details__pager.table-page-pagination {
  min-height: 78px;
  padding: 16px 18px;
  border-top: 1px solid #eef2f7;
  background: #ffffff;
  margin-top: 0;
}

.organic-tooltip {
  background: #f6f6f6;
  border: 1px solid #bfbfbf;
  box-shadow: 2px 3px 0 rgba(0, 0, 0, 0.18);
  padding: 8px 10px;
  min-width: 140px;
}
.organic-tooltip__row {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #585858;
  font-size: 12px;
}
.organic-tooltip__row strong {
  color: #2d2d2d;
  font-size: 12px;
  font-weight: 700;
}
.organic-tooltip--kpi {
  min-width: 250px;
  display: flex;
  padding: 0;
  border: 1px solid #cfd8e6;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.16);
}
.organic-tooltip__bar {
  width: 5px;
  background: #2b74e4;
  border-radius: 8px 0 0 8px;
  flex-shrink: 0;
}
.organic-tooltip__content {
  width: 100%;
  padding: 12px 16px 11px;
}
.organic-tooltip__kpi-title {
  color: #2f5f9f;
  font-size: 31px;
  font-weight: 700;
  line-height: 1.2;
}
.organic-tooltip__kpi-value {
  color: #1d4f91;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  margin-top: 1px;
}
.organic-tooltip__kpi-month {
  color: #2f5f9f;
  font-size: 14px;
  line-height: 1.2;
}
.organic-tooltip__divider {
  height: 1px;
  background: #b8c7dd;
  margin: 8px 0;
}
.organic-tooltip__mom-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
}
.organic-tooltip__mom-label {
  color: #4d6f9c;
  font-size: 30px;
  line-height: 1.1;
}
.organic-tooltip__mom-value {
  font-size: 30px;
  line-height: 1.1;
  font-weight: 700;
}
.organic-tooltip__mom-value--positive {
  color: #1b8e4a;
}
.organic-tooltip__mom-value--negative {
  color: #d93025;
}
.organic-tooltip__meta-line {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
}
.organic-tooltip__meta-label {
  color: #4d6f9c;
  font-size: 12px;
  line-height: 1.2;
}
.organic-tooltip__meta-value {
  color: #1d4f91;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
}

.organic-tabs-dashboard .recharts-tooltip-wrapper {
  z-index: 25;
  pointer-events: none;
}

.organic-kpi-card .recharts-tooltip-wrapper {
  margin-top: -18px;
}

.organic-tabs-dashboard .recharts-default-tooltip {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
}

@media (max-width: 1024px) {
  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__actions {
    margin-inline-start: auto;
    width: 100%;
    justify-content: flex-end;
  }
  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__actions--filters {
    grid-template-columns: max-content;
    justify-content: end;
    justify-items: stretch;
  }
  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__control,
  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__control--wide {
    min-width: 0;
    max-width: 100%;
  }
  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__control--wide {
    width: max-content;
  }
  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__control:not(.dashboard-section-header__control--wide) {
    width: 412px;
  }
  .organic-content-report__section-header .organic-content-report__caption-select {
    width: 100%;
  }
}
@media (max-width: 1150px) {
  .organic-tabs-dashboard:has(.organic-content-report) {
    display: block;
  }
  .organic-tabs-dashboard__tabs {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
  .organic-content-report {
    display: block;
  }
  .organic-content-report__toolbar {
    grid-template-columns: 1fr;
    grid-column: auto;
    justify-items: stretch;
    gap: 10px;
    margin-top: 12px;
  }
  .organic-content-report__toolbar-field,
  .organic-content-report__toolbar-field--range,
  .organic-content-report__toolbar-field--caption {
    width: 100%;
    min-width: 0;
  }
  .organic-content-report__toolbar-field--caption {
    margin-left: 0;
  }
  .organic-content-report__toolbar-field--caption > select {
    width: 100%;
  }
  .organic-tabs-dashboard__section-header-main,
  .organic-tabs-dashboard__section-header-picker {
    width: 100%;
    margin-left: 0;
  }
  .organic-tabs-dashboard__section-header-picker {
    justify-content: flex-start;
  }
  .organic-tabs-dashboard__section-header-picker.dashboard-filter-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .organic-tabs-dashboard__section-header-picker .organic-range-picker,
  .organic-tabs-dashboard__section-header-picker .organic-range-picker__control {
    width: 100%;
    max-width: none;
  }
}
@media (max-width: 1100px) {
  .organic-content-report__kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .organic-content-report__engagement-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .organic-content-report__chart-grid {
    grid-template-columns: 1fr;
  }
  .organic-tabs-dashboard__kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .organic-tabs-dashboard__bottom {
    grid-template-columns: 1fr;
  }
  .organic-visuals {
    grid-template-columns: 1fr;
  }
  .organic-followers-layout {
    grid-template-columns: 1fr;
  }
  .organic-followers-layout__kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: none;
  }
  .organic-instagram-layout {
    grid-template-columns: 1fr;
  }
  .organic-facebook-followers-layout {
    grid-template-columns: 1fr;
  }
  .organic-instagram-layout__top,
  .organic-instagram-layout__geo,
  .organic-facebook-followers-layout__top,
  .organic-facebook-followers-layout__geo {
    grid-template-columns: 1fr;
  }
  .organic-instagram-gender__content {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .organic-tabs-dashboard__section-header--followers {
    flex-direction: column;
    align-items: flex-start;
  }
  .organic-tabs-dashboard__section-header-picker {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }
  .organic-tabs-dashboard__section-header-picker .organic-range-picker,
  .organic-tabs-dashboard__section-header-picker .organic-range-picker__control {
    width: 100%;
    max-width: none;
  }
  .organic-tabs-dashboard:has(.organic-content-report) {
    display: block;
  }
  .organic-tabs-dashboard__tabs {
    grid-template-columns: 1fr;
    width: 100%;
  }
  .organic-content-report {
    display: block;
  }
  .organic-content-report__toolbar {
    grid-template-columns: 1fr;
    margin-top: 18px;
    gap: 10px;
  }
  .organic-content-report__toolbar-field,
  .organic-content-report__toolbar-field--range,
  .organic-content-report__toolbar-field--caption {
    width: 100%;
    min-width: 0;
  }
  .organic-range-picker,
  .organic-range-picker__control {
    width: 100%;
    max-width: none;
    justify-content: end;
  }
  .organic-content-report__toolbar-field--caption > select {
    width: 100%;
  }
  .organic-content-report__kpis {
    grid-template-columns: 1fr;
  }
  .organic-content-report__engagement-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .organic-tabs-dashboard {
    width: 100%;
  }
  .organic-tabs-dashboard__tabs {
    flex-wrap: wrap;
  }
  .organic-tabs-dashboard__tab {
    font-size: 12px;
    padding: 5px 8px;
  }
  .organic-tabs-dashboard__section-header h2 {
    font-size: 24px;
  }
  .organic-tabs-dashboard__filters {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 10px;
  }
  .organic-tabs-dashboard__filters label {
    min-width: 160px;
  }
  .organic-tabs-dashboard__filters label:first-child {
    min-width: 220px;
  }
  .organic-tabs-dashboard__kpis {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .organic-engagements {
    max-width: 100%;
  }
  .organic-engagements__tooltip {
    display: none;
  }
  .organic-kpi-card__content {
    grid-template-columns: 1fr;
    min-height: 0;
    gap: 4px;
  }
  .organic-kpi-card__meta {
    min-height: 0;
    padding-bottom: 0;
  }
  .organic-kpi-card__chart {
    height: 64px;
  }
  .organic-followers-layout__kpis {
    grid-template-columns: 1fr;
  }
  .organic-instagram-layout {
    grid-template-columns: 1fr;
  }
  .organic-instagram-layout__kpis {
    grid-template-columns: 1fr;
  }
  .organic-instagram-layout__top,
  .organic-instagram-layout__geo,
  .organic-facebook-followers-layout__top,
  .organic-facebook-followers-layout__geo {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .organic-facebook-followers-layout__kpis {
    grid-template-columns: 1fr;
  }
  .organic-instagram-layout .organic-followers-kpi--instagram {
    height: auto;
    min-height: 150px;
  }
  .organic-facebook-followers-layout .organic-followers-kpi--facebook-modern {
    height: auto;
    min-height: 150px;
  }
  .organic-instagram-gender {
    padding: 22px 18px;
  }
  .organic-instagram-gender__group {
    padding: 20px 16px;
  }
  .organic-instagram-gender__legend {
    grid-template-columns: 1fr;
  }
  .organic-instagram-ranked {
    padding: 24px 18px;
    min-height: 0;
  }
  .organic-followers-ranked {
    padding: 24px 18px;
    min-height: 0;
  }
  .organic-instagram-ranked__header,
  .organic-followers-ranked__header {
    flex-direction: column;
    margin-bottom: 24px;
  }
  .organic-instagram-ranked__control,
  .organic-followers-ranked__control {
    width: 100%;
    justify-content: space-between;
  }
  .organic-instagram-ranked__item,
  .organic-followers-ranked__item {
    grid-template-columns: 112px minmax(0, 1fr) 62px;
  }
  .organic-instagram-gender__tooltip {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/organicMedia/components/Tabs/OrganicTabsDashboard.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,UAAA;EACA,mBAAA;EACA,cAAA;EACA,mCAAA;AAAF;AAEE;EACE,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,QAAA;EACA,mBAAA;AAAJ;AAGE;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iDAAA;AADJ;AAGI;EACE,cAAA;EACA,mBAAA;AADN;AAKE;EACE,mBCrBI;EDsBJ,cAAA;EACA,gBC0LmB;AD7LvB;AAME;EACE,gCAAA;EACA,kBAAA;AAJJ;AAMI;EACE,eAAA;EACA,eC+KS;ED9KT,gBCiLa;EDhLb,cAAA;AAJN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,8BAAA;AANJ;AAQI;EACE,SAAA;EACA,cAAA;AANN;AAUE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AARJ;AAWE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AATJ;AAYE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAVJ;AAaE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAXJ;AAcE;EACE,gBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,mBAAA;EACA,mBCqEW;EDpEX,cCUW;EDTX,eC0GW;EDzGX,yBAAA;EACA,kBC8FQ;AD5GZ;AAiBE;EACE,kBAAA;EACA,kBAAA;EACA,cCdW;EDeX,eCiGW;ADhHf;AAkBE;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAhBN;AAmBI;EACE,gBAAA;AAjBN;AAoBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAlBN;AAqBI;;EAEE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBChJE;EDiJF,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,wDAAA;AAnBN;AAqBM;;EACE,qBAAA;EACA,8CAAA;AAlBR;AAsBI;EACE,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,0BAAA;AApBN;AAuBI;EACE,gBAAA;AArBN;AA0BE;EACE,2BAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAxBJ;AA2BE;EACE,kBAAA;EACA,aAAA;EACA,yDAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,2BAAA;AA1BJ;AA6BE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA3BJ;AA8BE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AA5BJ;AA+BE;EACE,SAAA;EACA,gBAAA;AA7BJ;AAgCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA9BJ;AAkCE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;AAjCJ;AAoCE;EACE,yBAAA;EACA,kBCvDQ;EDwDR,mBC5PI;ED6PJ,aAAA;EACA,cAAA;EACA,eClDW;ADgBf;;AAsCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAnCF;;AAsCA;EACE,cAAA;AAnCF;;AAsCA;EACE,kBAAA;AAnCF;;AAsCA;;EAEE,mBAAA;AAnCF;;AAsCA;EACE,iBAAA;AAnCF;;AAsCA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAnCF;AAqCE;;EAEE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,0DAAA;AAnCJ;AAqCI;;EACE,qBAAA;EACA,+CAAA;AAlCN;;AAuCA;EACE,WAAA;AApCF;;AAuCA;EACE,WAAA;EACA,eAAA;AApCF;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AApCF;;AAuCA;EACE;IACE,WAAA;EApCF;AACF;AAuCA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AArCF;;AAwCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AArCF;;AAwCA;;EAEE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AArCF;;AAwCA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,oBAAA;EACA,SAAA;AArCF;;AAwCA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;AArCF;AAuCE;EACE,kBAAA;AArCJ;;AAyCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAtCF;AAwCE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAtCJ;;AA0CA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AAvCF;;AA0CA;EACE,UAAA;EACA,QAAA;AAvCF;;AA0CA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAvCF;;AA0CA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,YAAA;EACA,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,2EAAA;EACA,oBAAA;EACA,uBAAA;AAvCF;;AA0CA;EACE;IACE,OAAA;IACA,WAAA;IACA,+BAAA;EAvCF;EA0CA;IACE,QAAA;IACA,UAAA;EAxCF;AACF;AA2CA;;EAEE,UAAA;EACA,mBAAA;EACA,wBAAA;AAzCF;;AA4CA;;EAEE,aAAA;AAzCF;;AA4CA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAzCF;;AA4CA;EACE,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAzCF;;AA4CA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAzCF;;AA4CA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAzCF;;AA4CA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAzCF;;AA4CA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAzCF;;AA4CA;EACE,aAAA;AAzCF;;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAzCF;;AA4CA;;EAEE,cAAA;EACA,eAAA;AAzCF;;AA4CA;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAzCF;;AA4CA;;EAEE,SAAA;EACA,WAAA;EACA,4CAAA;AAzCF;;AA4CA;;;;EAIE,yCAAA;AAzCF;;AA4CA;EAGE,OAAA;EACA,WAAA;EACA,2BAAA;AA3CF;;AA8CA;EAGE,UAAA;EACA,QAAA;EACA,2BAAA;AA7CF;;AAgDA;EAGE,UAAA;EACA,QAAA;EACA,2BAAA;AA/CF;;AAkDA;;;;EAgBE,wBAAA;AA3DF;;AA8DA;;EAQE,wBAAA;AAjEF;;AAoEA;;EAME,OAAA;EACA,WAAA;EACA,2BAAA;AArEF;;AAwEA;;;;EAgBE,wBAAA;AAjFF;;AAoFA;;EAME,UAAA;EACA,QAAA;EACA,2BAAA;AArFF;;AAwFA;;;;EAgBE,wBAAA;AAjGF;;AAoGA;EACE;;IAME,OAAA;IACA,WAAA;IACA,2BAAA;EArGF;EAwGA;;;;IAgBE,wBAAA;EAlHF;EAqHA;;IAME,UAAA;IACA,QAAA;IACA,2BAAA;EAvHF;EA0HA;;;;IAgBE,wBAAA;EApIF;EAuIA;IAGE,OAAA;IACA,WAAA;IACA,2BAAA;EAvIF;EA0IA;IAGE,UAAA;IACA,QAAA;IACA,2BAAA;EA1IF;EA6IA;IAGE,UAAA;IACA,QAAA;IACA,2BAAA;EA7IF;EAgJA;;;;IAgBE,wBAAA;EA1JF;EA6JA;;IAQE,wBAAA;EAjKF;AACF;AAoKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,uFAAA;EACA,cAAA;EACA,qBAAA;AAlKF;;AAqKA;EACE,cAAA;AAlKF;;AAqKA;EACE,cAAA;AAlKF;;AAqKA;EACE,cAAA;AAlKF;;AAqKA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AAlKF;AAoKE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAlKJ;;AAsKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAnKF;;AAsKA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAnKF;;AAsKA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AAnKF;;AAsKA;EACE,iBAAA;AAnKF;;AAsKA;EACE,aAAA;AAnKF;;AAsKA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;AAnKF;;AAsKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAnKF;;AAsKA;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAnKF;;AAsKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnKF;;AAsKA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAnKF;;AAsKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAnKF;;AAsKA;EACE,cAAA;AAnKF;;AAsKA;EACE,cAAA;AAnKF;;AAsKA;EACE,cAAA;AAnKF;;AAsKA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,MAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAnKF;;AAsKA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAnKF;;AAsKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;AAnKF;AAqKE;EACE,gBAAA;AAnKJ;;AAuKA;EACE,aAAA;EACA,QAAA;AApKF;;AAuKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AApKF;;AAuKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AApKF;;AAuKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AApKF;;AAuKA;EACE,cAAA;AApKF;;AAuKA;EACE,cAAA;AApKF;;AAuKA;EACE,cAAA;AApKF;;AAuKA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AApKF;;AAuKA;EACE,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mEAAA;AApKF;;AAuKA;;EAEE,WAAA;EACA,kBAAA;AApKF;;AAuKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AApKF;AAsKE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AApKJ;;AAwKA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AArKF;AAuKE;EACE,2BAAA;AArKJ;;AAyKA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAtKF;;AAyKA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAtKF;;AAyKA;EACE,qBAAA;AAtKF;;AAyKA;EACE,qBAAA;AAtKF;;AAyKA;EACE;IACE,eAAA;IACA,8BAAA;EAtKF;EAyKA;IACE,eAAA;IACA,WAAA;EAvKF;AACF;AA0KA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAxKF;;AA2KA;EACE,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAxKF;;AA2KA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAxKF;;AA2KA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAxKF;;AA2KA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAxKF;;AA2KA;EACE,cAAA;AAxKF;;AA4KA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAzKF;;AA6KA;EACE,aAAA;EACA,gDAAA;EACA,mCAAA;EACA,sBAAA;EACA,cAAA;AA1KF;;AA6KA;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA1KF;;AA6KA;EACE,WAAA;EACA,gBAAA;AA1KF;;AA6KA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA1KF;;AA6KA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1KF;;AA6KA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA1KF;;AA8KA;EACE,kBAAA;AA3KF;;AA8KA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;AA3KF;;AA8KA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA3KF;;AA8KA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA3KF;;AA8KA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3KF;;AA+KE;EACE,oBAAA;EACA,wBAAA;EACA,4BAAA;AA5KJ;AA+KE;;EAEE,iBAAA;AA7KJ;;AAiLA;EACE;IACE,oBAAA;IACA,wBAAA;IACA,4BAAA;EA9KF;AACF;AAiLA;EACE;IACE,gBAAA;IACA,WAAA;IACA,eAAA;EA/KF;AACF;AAkLA;EACE;IACE,gDAAA;EAhLF;EAmLA;IACE,iBAAA;EAjLF;AACF;AAoLA;EACE,uBAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;AAlLF;AAoLE;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gCAAA;AAlLJ;;AAsLA;EACE,oBAAA;EACA,iBAAA;EACA,iBAAA;AAnLF;;AAsLA;EACE,aAAA;EACA,sBAAA;AAnLF;;AAsLA;EACE,cAAA;AAnLF;;AAsLA;EACE,eAAA;EACA,iBAAA;AAnLF;;AAsLA;EACE,UAAA;EACA,iBAAA;AAnLF;;AAsLA;EACE,cAAA;EACA,gBAAA;AAnLF;;AAsLA,iIAAA;AACA;EACE,WAAA;EACA,kBAAA;AAnLF;;AAsLA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnLF;;AAsLA;EACE,gDAAA;EACA,gBAAA;AAnLF;;AAsLA;EACE,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAnLF;;AAsLA,oFAAA;AACA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAnLF;;AAsLA;EACE,UAAA;EACA,YAAA;AAnLF;;AAsLA;EACE,YAAA;AAnLF;;AAsLA;EACE,YAAA;AAnLF;;AAsLA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAnLF;;AAsLA;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAnLF;;AAsLA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAnLF;;AA0LA;EACE,qBAAA;AAvLF;;AA0LA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AAvLF;;AA0LA;EACE,YAAA;EACA,WAAA;AAvLF;;AA0LA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAvLF;;AA0LA;EACE,cAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAvLF;;AA0LA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAvLF;;AA0LA;EACE,cAAA;AAvLF;;AA0LA;;6CAAA;AAGA;EACE,UAAA;EACA,QAAA;AAvLF;;AA0LA,0EAAA;AACA;;EAEE,SAAA;EACA,wBAAA;AAvLF;;AA0LA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAvLF;;AA0LA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAvLF;;AA0LA;EACE,cAAA;EACE,mBAAA;EACA,qBAAA;AAvLJ;;AA0LA;EACC,cAAA;EACG,mBAAA;EACA,qBAAA;AAvLJ;;AA0LA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AAvLF;;AA0LA;EACE,mBAAA;EACA,kBAAA;AAvLF;;AA0LA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvLF;;AA0LA;;EAEE,gBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAvLF;;AA0LA;EACE,4BAAA;AAvLF;;AA0LA;EACE,4BAAA;AAvLF;;AA0LA;EACE,iBAAA;AAvLF;;AA0LA;;;;;;;;;EAAA;AAUA;EAIE,mBAAA;EAGA,iBAAA;AA5LF;;AA+LA;;EAEE,iBAAA;EACA,uBAAA;EACA,eAAA;EAGA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AA9LF;;AAiMA;EAEE,eAAA;AA/LF;;AAkMA;;EAEE,WAAA;AA/LF;;AAkMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kFAAA;EACA,qBAAA;AA/LF;;AAkMA;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AA/LF;;AAkMA;EACE,aAAA;EACA,mBAAA;AA/LF;;AAkMA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AA/LF;;AAkMA;EACE,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AA/LF;;AAkMA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AA/LF;;AAkMA;EACE,mBAAA;EACA,qBAAA;AA/LF;;AAkMA;EACE,aAAA;EACA,mBAAA;AA/LF;;AAkMA;EACE;IACE,WAAA;IACA,eAAA;EA/LF;EAkMA;IACE,YAAA;IACA,WAAA;IACA,SAAA;EAhMF;AACF;AAmMA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAjMF;;AAoMA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAjMF;;AAoMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gFAAA;AAjMF;;AAoMA;EACE,mBAAA;AAjMF;;AAoMA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAjMF;;AAoMA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAjMF;;AAoMA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAjMF;;AAoMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAjMF;;AAoMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,sGAAA;AAjMF;;AAoMA;EACE,mBAAA;AAjMF;;AAoMA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AAjMF;;AAoMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBChlDa;EDilDb,mBAAA;EACA,cCzxDM;ED0xDN,oBAAA;EACA,mBAAA;EACA,uBAAA;AAjMF;AAkME;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAhMJ;;AAoMA;EACE,WAAA;EACA,YAAA;EACA,mBClmDU;EDmmDV,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAjMF;;AAoMA;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,oBAAA;AAjMF;;AAoMA;EACE,iBAAA;EACA,iBAAA;AAjMF;AAmME;EACE,cAAA;AAjMJ;AAoME;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAlMJ;AAqME;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gFAAA;AAnMJ;AAqMI;EACE,cAAA;AAnMN;AAsMI;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AApMN;AAsMM;EACE,cAAA;AApMR;AAyME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvMJ;;AA2MA;EACE,aAAA;EACA,6BAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;AAxMF;;AA2MA;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,oBAAA;AAxMF;;AA2MA;EACE,aAAA;EACA,4BAAA;EACA,SAAA;AAxMF;;AA2MA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAxMF;;AA2MA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBC94DM;ED+4DN,iBAAA;EACA,kBAAA;AAxMF;AA0ME;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AAxMJ;AA2ME;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;EACA,qBAAA;AAzMJ;AA2MI;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AAzMN;AA6ME;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eC1uDW;ED2uDX,cAAA;AA3MJ;AA8ME;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AA5MJ;AA+ME;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AA7MJ;AAgNE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA9MJ;AAiNE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AA/MJ;AAkNE;EACE,cAAA;AAhNJ;AAkNI;EACE,cAAA;AAhNN;AAoNE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBC7xDmB;AD2kDvB;AAoNI;EACE,cAAA;AAlNN;AAqNI;EACE,cAAA;AAnNN;AAsNI;EACE,cAAA;AApNN;AAwNE;EACE,YAAA;EACA,kBAAA;EACA,WAAA;AAtNJ;;AA0NA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;AAvNF;AAyNE;EACE,oBAAA;AAvNJ;AA0NE;EACE,gBAAA;EACA,0CAAA;AAxNJ;AA2NE;EACE,UAAA;AAzNJ;AA4NE;EACE,YAAA;AA1NJ;;AA8NA;EACE,iBAAA;AA3NF;;AA8NA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBCpiEM;EDqiEN,kBAAA;AA3NF;AA6NE;EACE,eAAA;EACA,cAAA;EACA,eC71DW;ED81DX,gBCz1De;ED01Df,kBAAA;AA3NJ;AA8NE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AA5NJ;AA8NI;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AA5NN;AA+NI;EACE,wBAAA;AA7NN;AAiOE;EACE,aAAA;EACA,SAAA;AA/NJ;AAkOE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,gBAAA;AAhOJ;AAmOE;EACE,aAAA;EACA,0CAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AAjOJ;AAoOE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;AAlOJ;AAoOI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAlON;AAsOE;EACE,cAAA;EACA,eC15DW;ED25DX,cAAA;EACA,gBCz5De;ED05Df,cAAA;EACA,WAAA;EACA,SAAA;AApOJ;AAuOE;EACE,cAAA;EACA,eCv6DW;EDw6DX,iBAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;AArOJ;AAwOE;EACE,aAAA;EACA,QAAA;AAtOJ;AAyOE;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,8BAAA;AAvOJ;AAyOI;EACE,8BAAA;AAvON;AA0OI;EACE,8BAAA;AAxON;AA2OI;EACE,8BAAA;AAzON;AA4OI;EACE,8BAAA;AA1ON;AA6OI;EACE,8BAAA;AA3ON;AA8OI;EACE,8BAAA;AA5ON;AAgPE;EACE,cAAA;EACA,eCv9DW;EDw9DX,iBAAA;EACA,mBAAA;AA9OJ;AAiPE;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;AA/OJ;AAkPE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,sCAAA;EACA,cAAA;AAhPJ;AAkPI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBCx/DS;EDy/DT,sCAAA;AAhPN;AAoPE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AAlPJ;;AAsPA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBCltEM;EDmtEN,aAAA;EACA,mCAAA;EACA,oBAAA;EACA,iBAAA;AAnPF;AAqPE;EACE,eAAA;EACA,cAAA;EACA,eC9gEW;ED+gEX,gBC1gEe;ED2gEf,kBAAA;AAnPJ;AAsPE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AApPJ;AAsPI;EACE,SAAA;EACA,gBAAA;AApPN;AAwPE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eCxiEW;ADkzDf;AAyPE;EACE,aAAA;EACA,0BAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;AAvPJ;AAyPI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;AAvPN;AAyPM;EACE,cAAA;EACA,eC5jEO;ED6jEP,gBCtjEW;AD+zDnB;AA0PM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eCpkEO;AD40Df;AA4PI;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AA1PN;AA6PI;EACE,eCnlES;EDolET,cAAA;EACA,gBAAA;EACA,gCAAA;AA3PN;AA+PE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AA7PJ;AAgQE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;AA9PJ;AAiQE;EACE,qBAAA;AA/PJ;AAkQE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAhQJ;AAmQE;EACE,cCptEW;EDqtEX,eAAA;EACA,gBAAA;AAjQJ;AAoQE;EACE,2BAAA;EACA,4BAAA;AAlQJ;AAoQI;EACE,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AAlQN;AAoQM;EACE,8BAAA;AAlQR;AAqQM;EACE,8BAAA;AAnQR;AAsQM;EACE,8BAAA;AApQR;AAuQM;EACE,8BAAA;AArQR;AAwQM;EACE,8BAAA;AAtQR;AAyQM;EACE,8BAAA;AAvQR;AA0QM;EACE,SAAA;EACA,eChqEO;EDiqEP,cAAA;EACA,gBAAA;AAxQR;AA6QE;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,QAAA;AA3QJ;AA6QI;EACE,cAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;AA3QN;AA8QI;EACE,eCrrES;EDsrET,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA5QN;AA+QI;;EAEE,gBAAA;AA7QN;AAiRE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;AA/QJ;;AAmRA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,oBAAA;AAhRF;;AAmRA;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,oBAAA;AAhRF;;AAmRA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAhRF;;AAmRA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAhRF;AAkRE;EACE,mBAAA;EACA,qBAAA;AAhRJ;AAmRE;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAjRJ;AAoRE;EACE,cAAA;EACA,aAAA;AAlRJ;AAqRE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAnRJ;AAsRE;EACE,eAAA;EACA,cAAA;AApRJ;;AAwRA;EACE,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AArRF;AAuRE;EACE,mBAAA;AArRJ;AAwRE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAtRJ;AAyRE;EACE,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAvRJ;AA0RE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAxRJ;AA2RE;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAzRJ;;AA6RA;EACE,uBAAA;EACA,qBAAA;EACA,mBAAA;AA1RF;AA4RE;EACE,2BAAA;EACA,gBAAA;AA1RJ;AA4RI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA1RN;AA8RE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AA5RJ;AA+RE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AA7RJ;AAgSE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,kBAAA;AA9RJ;AAgSI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA9RN;AAkSE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AAhSJ;AAmSE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAjSJ;AAoSE;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAlSJ;AAqSE;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAnSJ;AAqSI;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAnSN;AAsSI;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApSN;AAuSI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AArSN;AAySE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAvSJ;;AA2SA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAxSF;;AA2SA;EACE,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAxSF;AA0SE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAxSJ;AA2SE;EACE,2BAAA;EACA,SAAA;AAzSJ;AA2SI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAzSN;AA8SI;EACE,wBAAA;AA5SN;AAgTE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA9SJ;AAgTI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,0BAAA;AA9SN;AAkTE;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAhTJ;AAmTE;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAjTJ;AAmTI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAjTN;AAqTE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnTJ;AAsTE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AApTJ;AAuTE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AArTJ;AAwTE;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAtTJ;AAyTE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAvTJ;;AA2TA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,oBAAA;AAxTF;;AA2TA;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,oBAAA;AAxTF;;AA2TA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAxTF;;AA2TA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAxTF;AA0TE;EACE,mBAAA;EACA,qBAAA;AAxTJ;AA2TE;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAzTJ;AA4TE;EACE,cAAA;EACA,aAAA;AA1TJ;AA6TE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AA3TJ;AA8TE;EACE,eAAA;EACA,cAAA;AA5TJ;;AAgUA;EACE,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AA7TF;AA+TE;EACE,mBAAA;AA7TJ;AAgUE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA9TJ;AAiUE;EACE,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA/TJ;AAkUE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAhUJ;AAmUE;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAjUJ;;AAqUA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAlUF;;AAqUA;EACE,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAlUF;AAoUE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAlUJ;AAqUE;EACE,2BAAA;EACA,SAAA;AAnUJ;AAqUI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAnUN;AAwUI;EACE,wBAAA;AAtUN;AA0UE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAxUJ;AA0UI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,0BAAA;AAxUN;AA4UE;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AA1UJ;AA6UE;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AA3UJ;AA6UI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA3UN;AA+UE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA7UJ;AAgVE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA9UJ;AAiVE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AA/UJ;AAkVE;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAhVJ;AAmVE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAjVJ;;AAqVA;EACE,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,sBAAA;EACA,mBC9+FM;ED++FN,iBAAA;AAlVF;AAoVE;EACE,eAAA;EACA,cAAA;EACA,eCvyFW;EDwyFX,gBCnyFe;EDoyFf,gBAAA;AAlVJ;AAqVE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;AAnVJ;AAsVE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wBAAA;AApVJ;AAuVE;EACE,eC5zFW;ED6zFX,cAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AArVJ;AAwVE;EACE,eCx0FW;EDy0FX,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAtVJ;AAyVE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBC/0FmB;ADw/EvB;AAyVI;EACE,cAAA;AAvVN;AA0VI;EACE,cAAA;AAxVN;AA4VE;EACE,aAAA;EACA,eAAA;AA1VJ;AA4VI;;;EAGE,4BAAA;AA1VN;;AA+VA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBC3jGM;ED4jGN,gBAAA;EACA,YAAA;AA5VF;AA8VE;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eCv3FW;EDw3FX,gBCn3Fe;EDo3Ff,gCAAA;AA5VJ;AA+VE;EACE,kBAAA;EACA,oBAAA;AA7VJ;AAgWE;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eCx4FW;EDy4FX,cAAA;EACA,eAAA;AA9VJ;AAgWI;EACE,kBAAA;EACA,cAAA;AA9VN;AAiWI;EACE,cAAA;EACA,eCn5FS;EDo5FT,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA/VN;AAkWI;EACE,mBAAA;AAhWN;AAoWE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AAlWJ;;AAsWA;EACE,yBAAA;EACA,mBAAA;EACA,mBCtnGM;EDunGN,kBAAA;EACA,aAAA;EACA,uDAAA;EACA,SAAA;AAnWF;;AAuWE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AApWJ;AAsWI;EACE,SAAA;EACA,cAAA;EACA,eC17FS;ED27FT,gBCt7Fa;ADklFnB;AAwWE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAtWJ;AAyWE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAvWJ;AAyWI;EACE,aAAA;AAvWN;AA2WE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,6BAAA;EACA,wBAAA;EACA,+BAAA;AAzWJ;AA4WE;EACE,0BAAA;AA1WJ;AA6WE;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,gDAAA;EACA,aAAA;AA3WJ;AA6WI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AA3WN;AA8WI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AA5WN;AA+WI;EACE,SAAA;EACA,eC7/FS;ED8/FT,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7WN;AAiXE;EACE,eAAA;AA/WJ;;AAoXE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAjXJ;AAmXI;EACE,SAAA;EACA,cAAA;EACA,eCnhGS;EDohGT,gBC/gGa;AD8pFnB;AAsXE;EACE,kBAAA;EACA,YAAA;AApXJ;AAuXE;EACE,WAAA;AArXJ;AAwXE;;EAEE,mBAAA;AAtXJ;AAyXE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAvXJ;AA0XE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,sGAAA;AAxXJ;AA2XE;EACE,mBAAA;AAzXJ;AA4XE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AA1XJ;;AA8XA;EACE,kBAAA;EACA,WAAA;AA3XF;;AA8XA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;AA3XF;;AA8XA;EACE,qBAAA;EACA,4CAAA;AA3XF;;AA8XA;EACE,qBAAA;EACA,+CAAA;AA3XF;;AA8XA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3XF;;AA8XA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA3XF;;AA8XA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AA3XF;;AA8XA;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;AA3XF;;AA8XA;EACE,mBAAA;AA3XF;;AA8XA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AA3XF;;AA8XA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA3XF;;AA8XA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3XF;;AA8XA;EACE,YAAA;EACA,mBAAA;EACA,mBCp4GM;EDq4GN,gBAAA;AA3XF;AA6XE;EACE,gCAAA;EACA,iBAAA;EACA,kBAAA;AA3XJ;AA6XI;EACE,SAAA;EACA,cAAA;EACA,eClsGS;EDmsGT,gBC9rGa;ADm0FnB;AA+XE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AA7XJ;AAgYE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AA9XJ;AAgYI;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBCr6GE;EDs6GF,cAAA;EACA,eC3tGS;ED4tGT,gBCvtGiB;EDwtGjB,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;AA9XN;AAiYI;EACE,kBAAA;EACF,eAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AA/XJ;AAkYI;EACE,mBC37GE;AD2jGR;AAoYE;EACE,UAAA;AAlYJ;AAqYE;EACE,SAAA;AAnYJ;AAsYE;EACE,UAAA;AApYJ;AAuYE;EACE,YAAA;AArYJ;AAwYE;EACE,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;AAtYJ;AAyYE;EACE,gBAAA;EACA,+BAAA;AAvYJ;AA0YE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAxYJ;AA2YE;EACE,2BAAA;EACA,4BAAA;EACA,+BAAA;AAzYJ;AA4YE;EAEE,2BAAA;AA3YJ;AA8YE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA5YJ;AA+YE;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AA7YJ;AAgZE;EACE,eAAA;EACA,4BAAA;AA9YJ;AAgZI;EACE,cAAA;AA9YN;AAkZE;EACE,cAAA;AAhZJ;AAmZE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,2BAAA;EACA,4BAAA;AAjZJ;AAoZE;EACE,cAAA;AAlZJ;AAqZE;EACE,oBAAA;EACA,sBAAA;EACA,QAAA;AAnZJ;AAqZI;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;AAnZN;AAsZI;EACE,UAAA;AApZN;AAuZI;EACE,UAAA;AArZN;AA0ZI;EACE,UAAA;AAxZN;AA2ZI;EACE,UAAA;AAzZN;AA4ZI;EACE,UAAA;AA1ZN;AA8ZE;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,cCnkHI;EDokHJ,eCv3GW;EDw3GX,gBCp3GmB;EDq3GnB,cAAA;AA5ZJ;AA+ZE;EACE,mBAAA;AA7ZJ;AAgaE;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eC34GW;ED44GX,gBCx4GmB;EDy4GnB,cAAA;AA9ZJ;AAiaE;EACE,mBAAA;EACA,cC/lHI;ADgsGR;;AAmaA,8HAAA;AACA;EAKE,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AApaF;;AAuaA;EACE,YAAA;AApaF;;AA0aA;EACE,YAAA;AAvaF;;AA0aA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;AAvaF;;AA0aA;EAGE,kBAAA;EACA,mBAAA;AAzaF;;AA4aA;EACE,kBAAA;AAzaF;;AA4aA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;AAzaF;;AA4aA;EACE,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,iBAAA;EACA,gBAAA;AAzaF;AA2aE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eCp9GW;AD2iGf;AA2aI;EACE,cAAA;EACA,eCx9GS;EDy9GT,gBCn9Ga;AD0iGnB;AA6aE;EACE,gBAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,kBC1+GQ;ED2+GR,mBC/qHI;EDgrHJ,0CAAA;AA3aJ;AA8aE;EACE,UAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;AA5aJ;AA+aE;EACE,WAAA;EACA,uBAAA;AA7aJ;AAgbE;EACE,cAAA;EACA,eAAA;EACA,gBCh/Ge;EDi/Gf,gBAAA;AA9aJ;AAibE;EACE,cAAA;EACA,eC3/GW;ED4/GX,gBCv/Ge;EDw/Gf,gBAAA;EACA,eAAA;AA/aJ;AAkbE;EACE,cAAA;EACA,eCngHW;EDogHX,gBAAA;AAhbJ;AAmbE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;AAjbJ;AAobE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAlbJ;AAqbE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAnbJ;AAsbE;EACE,eAAA;EACA,gBAAA;EACA,gBCxhHe;ADomGnB;AAubE;EACE,cAAA;AArbJ;AAwbE;EACE,cCvnHW;ADisGf;AAybE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAvbJ;AA0bE;EACE,cAAA;EACA,eCljHW;EDmjHX,gBAAA;AAxbJ;AA2bE;EACE,cAAA;EACA,eCxjHW;EDyjHX,gBAAA;EACA,gBCpjHe;AD2nGnB;;AA6bA;EACE,WAAA;EACA,oBAAA;AA1bF;;AA6bA;EACE,iBAAA;AA1bF;;AA6bA;EACE,kCAAA;EACA,oBAAA;EACA,2BAAA;EACA,qBAAA;AA1bF;;AA6bA;EACE;IACE,yBAAA;IACA,WAAA;IACA,yBAAA;EA1bF;EA6bA;IACE,kCAAA;IACA,oBAAA;IACA,sBAAA;EA3bF;EA8bA;;IAEE,YAAA;IACA,eAAA;EA5bF;EA+bA;IACE,kBAAA;EA7bF;EAgcA;IACE,YAAA;EA9bF;EAicA;IACE,WAAA;EA/bF;AACF;AAkcA;EACE;IACE,cAAA;EAhcF;EAmcA;IACE,WAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;EAjcF;EAocA;IACE,cAAA;EAlcF;EAqcA;IACE,0BAAA;IACA,iBAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;EAncF;EAscA;;;IAGE,WAAA;IACA,YAAA;EApcF;EAucA;IACE,cAAA;EArcF;EAwcA;IACE,WAAA;EAtcF;EAycA;;IAEE,WAAA;IACA,cAAA;EAvcF;EA0cA;IACE,2BAAA;EAxcF;EA2cA;IACE,aAAA;IACA,mBAAA;IACA,SAAA;EAzcF;EA4cA;;IAEE,WAAA;IACA,eAAA;EA1cF;AACF;AA6cA;EACE;IACE,gDAAA;EA3cF;EA8cA;IACE,gDAAA;EA5cF;EA+cA;IACE,0BAAA;EA7cF;EAgdA;IACE,gDAAA;EA9cF;EAidA;IACE,0BAAA;EA/cF;EAkdA;IACE,0BAAA;EAhdF;EAmdA;IACE,0BAAA;EAjdF;EAodA;IACE,gDAAA;IACA,wBAAA;EAldF;EAqdA;IACE,0BAAA;EAndF;EAsdA;IACE,0BAAA;EApdF;EAudA;;;;IAIE,0BAAA;EArdF;EAwdA;IACE,0BAAA;EAtdF;AACF;AAydA;EACE;IACE,sBAAA;IACA,uBAAA;EAvdF;EA0dA;IACE,WAAA;IACA,cAAA;IACA,2BAAA;EAxdF;EA2dA;;IAEE,WAAA;IACA,eAAA;EAzdF;EA4dA;IACE,cAAA;EA1dF;EA6dA;IAEE,0BAAA;IACA,WAAA;EA5dF;EA+dA;IACE,cAAA;EA7dF;EAgeA;IACE,0BAAA;IACA,gBAAA;IACA,SAAA;EA9dF;EAieA;;;IAGE,WAAA;IACA,YAAA;EA/dF;EAkeA;;IAEE,WAAA;IACA,eAAA;IACA,oBAAA;EAheF;EAmeA;IACE,WAAA;EAjeF;EAoeA;IACE,0BAAA;EAleF;EAqeA;IACE,gDAAA;EAneF;EAseA;IACE,WAAA;EApeF;EAseE;IACE,eAAA;EApeJ;EAueE;IACE,eC1yHS;ID2yHT,gBAAA;EAreJ;EAweE;IACE,eAAA;EAteJ;EAyeE;IACE,2BAAA;IACA,eAAA;IACA,SAAA;EAveJ;EAyeI;IACE,gBAAA;EAveN;EA0eI;IACE,gBAAA;EAxeN;EA4eE;IACE,0BAAA;IACA,SAAA;EA1eJ;EA8eA;IACE,eAAA;EA5eF;EA+eA;IACE,aAAA;EA7eF;EAgfA;IACE,0BAAA;IACA,aAAA;IACA,QAAA;EA9eF;EAifA;IACE,aAAA;IACA,iBAAA;EA/eF;EAkfA;IACE,YAAA;EAhfF;EAmfA;IACE,0BAAA;EAjfF;EAofA;IACE,0BAAA;EAlfF;EAqfA;IACE,0BAAA;EAnfF;EAsfA;;;;IAIE,0BAAA;IACA,SAAA;EApfF;EAufA;IACE,0BAAA;EArfF;EAwfA;IACE,YAAA;IACA,iBAAA;EAtfF;EAyfA;IACE,YAAA;IACA,iBAAA;EAvfF;EA0fA;IACE,kBAAA;EAxfF;EA2fA;IACE,kBAAA;EAzfF;EA4fA;IACE,0BAAA;EA1fF;EA6fA;IACE,kBAAA;IACA,aAAA;EA3fF;EA8fA;IACE,kBAAA;IACA,aAAA;EA5fF;EA+fA;;IAEE,sBAAA;IACA,mBAAA;EA7fF;EAggBA;;IAEE,WAAA;IACA,8BAAA;EA9fF;EAigBA;;IAEE,gDAAA;EA/fF;EAkgBA;IACE,aAAA;EAhgBF;AACF","sourcesContent":["@import \"../../../../styles/variables\";\n\n.organic-tabs-dashboard {\n  width: 98%;\n  margin: 0 auto 10px;\n  color: #0d468f;\n  font-family: \"opensans\", sans-serif;\n\n  &__tabs {\n    display: flex;\n    align-items: flex-end;\n    border-bottom: 1px solid #d4d4d4;\n    gap: 2px;\n    margin-bottom: 10px;\n  }\n\n  &__tab {\n    border: 1px solid #c7c7c7;\n    border-bottom: 0;\n    background: #ececec;\n    color: #4f4f4f;\n    padding: 4px 12px;\n    font-size: 13px;\n    line-height: 1.15;\n    cursor: pointer;\n    transition: color 0.2s ease, background 0.2s ease;\n\n    &:hover {\n      color: #0d468f;\n      background:#ffffff;\n    }\n  }\n\n  &__tab--active {\n    background: $white;\n    color: #0d468f;\n    font-weight: $font-weight-semibold;\n  }\n\n  &__section-header {\n    border-bottom: 1px solid #d5d5d5;\n    margin-bottom: 8px;\n\n    h2 {\n      margin: 0 0 6px;\n      font-size: $font-size-xl;\n      font-weight: $font-weight-bold;\n      color: #0d468f;\n    }\n  }\n\n  &__section-header--followers {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 14px;\n    flex-wrap: nowrap;\n    margin-bottom: 10px !important;\n\n    h2 {\n      margin: 0;\n      color: #0f172a;\n    }\n  }\n\n  &__section-header-main {\n    display: inline-flex;\n    align-items: center;\n    gap: 14px;\n    min-width: 0;\n    margin-bottom: 5px;\n  }\n\n  &__section-header-copy {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n  }\n\n  &__section-header-title-row {\n    display: inline-flex;\n    align-items: center;\n    gap: 14px;\n    min-width: 0;\n  }\n\n  &__section-subtitle {\n    margin: 0;\n    color: #64748b;\n    font-size: 14px;\n    line-height: 1.4;\n  }\n\n  &__section-header--followers-no-divider {\n    border-bottom: 0;\n    margin-bottom: 0;\n  }\n\n  &__section-header-picker {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-left: auto;\n    min-width: 0;\n  }\n\n  &__error {\n    padding: 12px 16px;\n    margin-bottom: 12px;\n    background: $color-fef2f2;\n    color: $color-b91c1c;\n    font-size: $font-size-md;\n    border: 1px solid $color-fecaca;\n    border-radius: $radius-sm;\n  }\n\n  &__loading {\n    padding: 32px 16px;\n    text-align: center;\n    color: $color-64748b;\n    font-size: $font-size-md;\n  }\n\n  &__filters {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n    gap: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #d8dde6;\n    margin-bottom: 14px;\n\n    label {\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      min-width: 178px;\n    }\n\n    label:first-child {\n      min-width: 320px;\n    }\n\n    span {\n      color: #0d468f;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 1.2;\n    }\n\n    select,\n    input {\n      height: 40px;\n      border: 1px solid #cfd6e1;\n      border-radius: 6px;\n      padding: 0 12px;\n      background: $white;\n      color: #1f1f1f;\n      font-size: 14px;\n      outline: none;\n      box-sizing: border-box;\n      transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n      &:focus {\n        border-color: #2f66ab;\n        box-shadow: 0 0 0 2px rgba(47, 102, 171, 0.14);\n      }\n    }\n\n    select {\n      padding-right: 38px;\n      appearance: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2.2 4.5L6 8.2l3.8-3.7' fill='none' stroke='%231f1f1f' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n      background-repeat: no-repeat;\n      background-position: right 12px center;\n      background-size: 12px 12px;\n    }\n\n    input[type=\"date\"] {\n      min-width: 176px;\n    }\n  }\n\n\n  &__filters--followers {\n    justify-content: flex-start;\n    padding-bottom: 18px;\n    border-bottom: 0;\n    margin-bottom: 18px;\n  }\n\n  &__range-filter {\n    position: relative;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n    align-items: center;\n    gap: 12px;\n    min-width: 320px;\n    max-width: 440px;\n    height: 58px;\n    padding: 0 16px 0 50px;\n    border: 1px solid #ccd6e3;\n    border-radius: 16px;\n    background: #ffffff;\n  }\n\n  &__range-icon {\n    position: absolute;\n    left: 18px;\n    top: 50%;\n    width: 18px;\n    height: 18px;\n    color: #64748b;\n    transform: translateY(-50%);\n  }\n\n  &__range-icon svg {\n    display: block;\n    width: 18px;\n    height: 18px;\n  }\n\n  &__range-filter input {\n    width: 100%;\n    min-width: 0;\n    height: 100%;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  &__range-filter input:focus {\n    border: 0;\n    box-shadow: none;\n  }\n\n  &__range-separator {\n    color: #64748b;\n    font-size: 18px;\n    font-weight: 500;\n  }\n\n\n  &__kpis {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n    margin-bottom: 14px;\n  }\n\n  &__bottom {\n    display: grid;\n    grid-template-columns: 360px minmax(0, 1fr);\n    gap: 12px;\n    margin-bottom: 10px;\n    align-items: stretch;\n  }\n\n  &__coming-soon {\n    border: 1px solid #cbd9ea;\n    border-radius: $radius-md;\n    background: $white;\n    padding: 14px;\n    color: #5e6a7f;\n    font-size: $font-size-md;\n  }\n}\n\n.organic-tabs-dashboard__tabs {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px;\n  border-bottom: 0;\n  border-radius: 14px;\n  background: #edf1f6;\n  margin: 0 0 22px;\n}\n\n.organic-tabs-dashboard__tab {\n  min-height: 40px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  padding: 8px 18px;\n  font-size: 12px;\n  font-weight: 600;\n  box-shadow: none;\n}\n\n.organic-tabs-dashboard__tab--active {\n  background: #ffffff;\n  color: #111827;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.organic-content-report {\n  display: block;\n}\n\n.organic-content-report__section-header {\n  margin-bottom: 4px;\n}\n\n.organic-content-report .dashboard-narrative-panel,\n.organic-tabs-dashboard .dashboard-narrative-panel {\n  margin-bottom: 14px;\n}\n\n.organic-content-report__toolbar-field--caption {\n  margin-left: -2px;\n}\n\n.organic-content-report__toolbar-field {\n  position: relative;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  align-self: start;\n\n  > select,\n  > input {\n    width: 100%;\n    height: 44px;\n    border: 1px solid #ccd6e3;\n    border-radius: 8px;\n    background: #ffffff;\n    padding: 0 16px 0 50px;\n    color: #0f172a;\n    font-size: 13px;\n    outline: none;\n    transition: border-color 0.18s ease, box-shadow 0.18s ease;\n\n    &:focus {\n      border-color: #9fb3cd;\n      box-shadow: 0 0 0 3px rgba(159, 179, 205, 0.18);\n    }\n  }\n}\n\n.organic-content-report__toolbar-field--caption > .organic-custom-select {\n  width: 100%;\n}\n\n.organic-content-report__caption-select .organic-custom-select__dropdown {\n  width: 100%;\n  min-width: 100%;\n}\n\n.organic-content-report__toolbar-field--range {\n  display: flex;\n  align-items: center;\n  width: max-content;\n}\n\n@media (max-width: 700px) {\n  .organic-content-report__toolbar-field--range {\n    width: 100%;\n  }\n}\n\n.organic-content-report__kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.organic-content-report__loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 260px;\n}\n\n.organic-content-card,\n.organic-content-panel {\n  border: 1px solid #dbe4f0;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: none;\n}\n\n.organic-content-card {\n  min-height: 122px;\n  padding: 18px 20px;\n  display: grid;\n  grid-template-rows: auto auto;\n  align-content: start;\n  gap: 12px;\n}\n\n.organic-content-card__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n\n  > div:first-child {\n    position: relative;\n  }\n}\n\n.organic-content-card__title-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n\n  h3 {\n    margin: 0;\n    color: #667085;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n  }\n}\n\n.organic-content-card__title-help-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  z-index: 2;\n  isolation: isolate;\n}\n\n.organic-content-card__title-help-wrap--end .organic-content-card__definition-tooltip {\n  left: auto;\n  right: 0;\n}\n\n.organic-content-card__title-help {\n  width: 14px;\n  height: 14px;\n  border: 1px solid #c6d3e4;\n  border-radius: 50%;\n  background: #eef4fb;\n  color: #7f93ad;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  font-size: 10px;\n  line-height: 1;\n  font-weight: 700;\n  cursor: default;\n}\n\n.organic-content-card__definition-tooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  width: 320px;\n  max-width: min(320px, calc(100vw - 40px));\n  border-radius: 12px;\n  border: 1px solid #d9e3f2;\n  background: #ffffff;\n  box-shadow: 0 10px 24px rgba(14, 30, 62, 0.16);\n  padding: 14px;\n  z-index: 5000;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-2px);\n  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;\n  pointer-events: none;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 900px) {\n  .organic-content-card__definition-tooltip {\n    left: 0;\n    right: auto;\n    width: min(320px, calc(100vw - 40px));\n  }\n\n  .organic-content-card__title-help-wrap--end .organic-content-card__definition-tooltip {\n    right: 0;\n    left: auto;\n  }\n}\n\n.organic-content-card__title-help-wrap:hover .organic-content-card__definition-tooltip,\n.organic-content-card__title-help-wrap:focus-within .organic-content-card__definition-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.organic-content-card__title-help-wrap:hover,\n.organic-content-card__title-help-wrap:focus-within {\n  z-index: 5000;\n}\n\n.organic-content-card__definition-text {\n  margin: 0 0 12px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.35;\n  color: #6a7282;\n}\n\n.organic-content-card__definition-formula-box {\n  border-radius: 10px;\n  background: #e8f0fb;\n  border-left: 4px solid #1f5da8;\n  padding: 10px 12px 12px;\n}\n\n.organic-content-card__definition-formula-title {\n  margin: 0 0 4px;\n  font-size: 13px;\n  line-height: 1;\n  color: #6a7282;\n  font-weight: 700;\n}\n\n.organic-content-card__definition-formula {\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.35;\n  color: #6a7282;\n  font-weight: 500;\n}\n\n.organic-content-card__value {\n  font-size: 24px;\n  line-height: 1.2;\n  color: #0f172a;\n  font-weight: 700;\n  unicode-bidi: plaintext;\n}\n\n.organic-content-card__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  background: #eef4ff;\n  color: #356fb6;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.organic-content-card__footer {\n  margin-top: 0;\n}\n\n.organic-content-card__period {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #667085;\n  font-size: 13px;\n  font-weight: 500;\n  flex-wrap: wrap;\n  line-height: 1.5;\n}\n\n.organic-content-card__period--unavailable,\n.organic-engagement-card__period--unavailable {\n  color: #98a2b3;\n  font-size: 12px;\n}\n\n.organic-content-card__period--unavailable .definition-tooltip__trigger,\n.organic-engagement-card__period--unavailable .definition-tooltip__trigger {\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  font-size: 10px;\n}\n\n.organic-content-card__period--unavailable .definition-tooltip__popover,\n.organic-engagement-card__period--unavailable .definition-tooltip__popover {\n  left: 50%;\n  right: auto;\n  transform: translateX(-50%) translateY(-2px);\n}\n\n.organic-content-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,\n.organic-content-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover,\n.organic-engagement-card__period--unavailable .definition-tooltip:hover .definition-tooltip__popover,\n.organic-engagement-card__period--unavailable .definition-tooltip:focus-within .definition-tooltip__popover {\n  transform: translateX(-50%) translateY(0);\n}\n\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n + 1)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip__popover {\n  left: 0;\n  right: auto;\n  transform: translateY(-2px);\n}\n\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip__popover {\n  left: auto;\n  right: 0;\n  transform: translateY(-2px);\n}\n\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n + 2)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip__popover {\n  left: auto;\n  right: 0;\n  transform: translateY(-2px);\n}\n\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n + 1)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:hover\n  .definition-tooltip__popover,\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n + 1)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:focus-within\n  .definition-tooltip__popover,\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:hover\n  .definition-tooltip__popover,\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-child(4n)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:focus-within\n  .definition-tooltip__popover {\n  transform: translateY(0);\n}\n\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n + 2)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:hover\n  .definition-tooltip__popover,\n.organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n + 2)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:focus-within\n  .definition-tooltip__popover {\n  transform: translateY(0);\n}\n\n.organic-content-report__kpis > .organic-content-card:nth-child(4n + 1)\n  .organic-content-card__period--unavailable\n  .definition-tooltip__popover,\n.organic-content-report__kpis > .organic-engagement-card:nth-child(4n + 1)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip__popover {\n  left: 0;\n  right: auto;\n  transform: translateY(-2px);\n}\n\n.organic-content-report__kpis > .organic-content-card:nth-child(4n + 1)\n  .organic-content-card__period--unavailable\n  .definition-tooltip:hover\n  .definition-tooltip__popover,\n.organic-content-report__kpis > .organic-content-card:nth-child(4n + 1)\n  .organic-content-card__period--unavailable\n  .definition-tooltip:focus-within\n  .definition-tooltip__popover,\n.organic-content-report__kpis > .organic-engagement-card:nth-child(4n + 1)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:hover\n  .definition-tooltip__popover,\n.organic-content-report__kpis > .organic-engagement-card:nth-child(4n + 1)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:focus-within\n  .definition-tooltip__popover {\n  transform: translateY(0);\n}\n\n.organic-content-report__kpis > .organic-content-card:nth-child(4n)\n  .organic-content-card__period--unavailable\n  .definition-tooltip__popover,\n.organic-content-report__kpis > .organic-engagement-card:nth-child(4n)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip__popover {\n  left: auto;\n  right: 0;\n  transform: translateY(-2px);\n}\n\n.organic-content-report__kpis > .organic-content-card:nth-child(4n)\n  .organic-content-card__period--unavailable\n  .definition-tooltip:hover\n  .definition-tooltip__popover,\n.organic-content-report__kpis > .organic-content-card:nth-child(4n)\n  .organic-content-card__period--unavailable\n  .definition-tooltip:focus-within\n  .definition-tooltip__popover,\n.organic-content-report__kpis > .organic-engagement-card:nth-child(4n)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:hover\n  .definition-tooltip__popover,\n.organic-content-report__kpis > .organic-engagement-card:nth-child(4n)\n  .organic-engagement-card__period--unavailable\n  .definition-tooltip:focus-within\n  .definition-tooltip__popover {\n  transform: translateY(0);\n}\n\n@media (max-width: 1200px) {\n  .organic-content-report__kpis > .organic-content-card:nth-child(2n + 1)\n    .organic-content-card__period--unavailable\n    .definition-tooltip__popover,\n  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n + 1)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip__popover {\n    left: 0;\n    right: auto;\n    transform: translateY(-2px);\n  }\n\n  .organic-content-report__kpis > .organic-content-card:nth-child(2n + 1)\n    .organic-content-card__period--unavailable\n    .definition-tooltip:hover\n    .definition-tooltip__popover,\n  .organic-content-report__kpis > .organic-content-card:nth-child(2n + 1)\n    .organic-content-card__period--unavailable\n    .definition-tooltip:focus-within\n    .definition-tooltip__popover,\n  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n + 1)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:hover\n    .definition-tooltip__popover,\n  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n + 1)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:focus-within\n    .definition-tooltip__popover {\n    transform: translateY(0);\n  }\n\n  .organic-content-report__kpis > .organic-content-card:nth-child(2n)\n    .organic-content-card__period--unavailable\n    .definition-tooltip__popover,\n  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip__popover {\n    left: auto;\n    right: 0;\n    transform: translateY(-2px);\n  }\n\n  .organic-content-report__kpis > .organic-content-card:nth-child(2n)\n    .organic-content-card__period--unavailable\n    .definition-tooltip:hover\n    .definition-tooltip__popover,\n  .organic-content-report__kpis > .organic-content-card:nth-child(2n)\n    .organic-content-card__period--unavailable\n    .definition-tooltip:focus-within\n    .definition-tooltip__popover,\n  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:hover\n    .definition-tooltip__popover,\n  .organic-content-report__kpis > .organic-engagement-card:nth-child(2n)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:focus-within\n    .definition-tooltip__popover {\n    transform: translateY(0);\n  }\n\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n + 1)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip__popover {\n    left: 0;\n    right: auto;\n    transform: translateY(-2px);\n  }\n\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip__popover {\n    left: auto;\n    right: 0;\n    transform: translateY(-2px);\n  }\n\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n + 2)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip__popover {\n    left: auto;\n    right: 0;\n    transform: translateY(-2px);\n  }\n\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n + 1)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:hover\n    .definition-tooltip__popover,\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n + 1)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:focus-within\n    .definition-tooltip__popover,\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:hover\n    .definition-tooltip__popover,\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-child(2n)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:focus-within\n    .definition-tooltip__popover {\n    transform: translateY(0);\n  }\n\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n + 2)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:hover\n    .definition-tooltip__popover,\n  .organic-content-report__engagement-grid > .organic-engagement-card:nth-last-child(-n + 2)\n    .organic-engagement-card__period--unavailable\n    .definition-tooltip:focus-within\n    .definition-tooltip__popover {\n    transform: translateY(0);\n  }\n}\n\n.organic-content-card__change {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 700;\n  /* See `.dashboard-kpi-card__change` — keeps \"↘ -13.2%\" from rendering as \"↘ %13.2-\". */\n  direction: ltr;\n  unicode-bidi: isolate;\n}\n\n.organic-content-card__change--positive {\n  color: #0f9f60;\n}\n\n.organic-content-card__change--negative {\n  color: #d92d20;\n}\n\n.organic-content-card__change--neutral {\n  color: #667085;\n}\n\n.organic-content-report__engagement-block {\n  display: grid;\n  gap: 20px;\n  grid-column: 1 / -1;\n\n  h2 {\n    margin: 0;\n    color: #000000;\n    font-size: 18px;\n    font-weight: 700;\n  }\n}\n\n.organic-content-report__section-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.organic-content-report__engagement-grid {\n  position: relative;\n  z-index: 10;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 14px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.organic-engagement-card {\n  position: relative;\n  min-height: 96px;\n  padding: 18px 20px;\n  border: 1px solid #dbe4f0;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: none;\n  display: grid;\n  align-content: start;\n  gap: 10px;\n  justify-items: start;\n  text-align: left;\n}\n\n.organic-engagement-card--dropdown {\n  overflow: visible;\n}\n\n.organic-engagement-card--dropdown-open {\n  z-index: 7000;\n}\n\n.organic-engagement-card__label-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n}\n\n.organic-engagement-card__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #667085;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.organic-engagement-card__toggle {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: #7c8ea5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.organic-engagement-card__value {\n  color: #101828;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.organic-engagement-card__period {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  min-height: 18px;\n  color: #667085;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.2;\n  flex-wrap: wrap;\n}\n\n.organic-engagement-card__change {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-right: 4px;\n  font-weight: 700;\n}\n\n.organic-engagement-card__change--positive {\n  color: #16a34a;\n}\n\n.organic-engagement-card__change--negative {\n  color: #ef4444;\n}\n\n.organic-engagement-card__change--neutral {\n  color: #667085;\n}\n\n.organic-engagement-card__dropdown {\n  position: absolute;\n  top: 34px;\n  right: 14px;\n  min-width: 188px;\n  padding: 4px 0;\n  border: 1px solid #d8e0ea;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.16);\n  display: grid;\n  gap: 0;\n  z-index: 7001;\n  text-align: left;\n  overflow: hidden;\n}\n\n.organic-engagement-card__dropdown--portal {\n  position: fixed;\n  top: auto;\n  right: auto;\n  z-index: 2147483000;\n}\n\n.organic-engagement-card__dropdown-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 12px 16px 11px;\n  border-bottom: 1px solid #e8edf3;\n\n  &:last-child {\n    border-bottom: 0;\n  }\n}\n\n.organic-engagement-card__dropdown-metric {\n  display: grid;\n  gap: 2px;\n}\n\n.organic-engagement-card__dropdown-label {\n  color: #4b5563;\n  font-size: 11px;\n  line-height: 1.2;\n}\n\n.organic-engagement-card__dropdown-value {\n  color: #0f172a;\n  font-size: 14px;\n  line-height: 1.1;\n  font-weight: 700;\n}\n\n.organic-engagement-card__dropdown-trend {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  margin-top: 2px;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.organic-engagement-card__dropdown-trend--positive {\n  color: #16a34a;\n}\n\n.organic-engagement-card__dropdown-trend--negative {\n  color: #ef4444;\n}\n\n.organic-engagement-card__dropdown-trend--neutral {\n  color: #667085;\n}\n\n.organic-content-report__chart-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 22px;\n  grid-column: 1 / -1;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.organic-content-panel {\n  position: relative;\n  padding: 24px 22px 22px;\n  overflow: visible;\n  min-height: auto;\n  border: 1px solid #e5e7f0;\n  border-radius: 20px;\n  background: #ffffff;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, z-index 0s;\n}\n\n.organic-content-panel:hover,\n.organic-content-panel:focus-within {\n  z-index: 20;\n  position: relative;\n}\n\n.organic-content-panel__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 16px;\n  margin-bottom: 28px;\n  position: relative;\n  z-index: 1;\n\n  h3 {\n    margin: 0;\n    color: #101828;\n    font-size: 16px;\n    font-weight: 700;\n  }\n}\n\n.organic-content-panel__title {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n  position: relative;\n\n  .organic-content-card__title-help-wrap {\n    transform: translateY(-1px);\n  }\n}\n\n.organic-bars__select-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  min-width: 140px;\n  max-width: 200px;\n}\n\n.organic-bars__select .organic-custom-select__trigger {\n  background: #f8fafc;\n  border-color: #d6d9e7;\n  color: #0f172a;\n  min-height: 44px;\n}\n\n.organic-bars__select .organic-custom-select__trigger:hover {\n  border-color: #bac4d5;\n}\n\n.organic-bars__select .organic-custom-select__dropdown {\n  border-color: #d8e1ef;\n}\n\n@media (max-width: 700px) {\n  .organic-content-panel__header {\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n\n  .organic-bars__select-wrap {\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\n.organic-content-panel__trend-legend {\n  display: flex;\n  justify-content: center;\n  gap: 28px;\n  padding-top: 6px;\n}\n\n.organic-content-panel__donut {\n  position: relative;\n  width: min(270px, 100%);\n  height: 270px;\n  margin: 12px auto 28px;\n}\n\n.organic-content-panel__segmented {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 3px;\n  border: 1px solid #d7e1ee;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.organic-content-panel__segmented-button {\n  min-width: 68px;\n  height: 30px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.organic-content-panel__segmented-button--active {\n  background: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.organic-content-panel__pie-legend {\n  padding-top: 0;\n}\n\n// 3 or fewer slices: a single column, centered under the donut.\n.organic-content-panel__pie-legend--centered {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n}\n\n// More than 3 slices: two columns, 3 rows each (first 3 items left, rest right).\n.organic-content-panel__pie-legend--columns {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-template-rows: repeat(3, auto);\n  grid-auto-flow: column;\n  gap: 18px 30px;\n}\n\n.organic-content-panel__pie-legend-item {\n  display: grid;\n  grid-template-columns: 16px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  color: #667085;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.organic-content-panel__pie-legend--centered .organic-content-panel__pie-legend-item {\n  width: 100%;\n  max-width: 220px;\n}\n\n.organic-content-panel__pie-legend-swatch {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.organic-content-panel__pie-legend-text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.organic-content-panel__pie-legend-item strong {\n  color: #000;\n  font-size: 13px;\n  font-weight: 800;\n  text-align: right;\n  white-space: nowrap;\n}\n\n// Centered total shown inside the content-breakdown donut hole.\n.organic-content-panel__donut {\n  position: relative;\n}\n\n.organic-content-panel__donut-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  text-align: center;\n}\n\n.organic-content-panel__donut-center-value {\n  color: #0f172a;\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.organic-content-panel__donut-center-label {\n  margin-top: 4px;\n  color: #5e6a7d;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.organic-content-panel__trend-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #5f748f;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.organic-content-panel--trends {\n  .organic-content-panel__trends-chart {\n    margin-inline: -18px;\n    width: calc(100% + 36px);\n    max-width: calc(100% + 36px);\n  }\n\n  .recharts-responsive-container,\n  .recharts-wrapper {\n    overflow: visible;\n  }\n}\n\n@media (max-width: 900px) {\n  .organic-content-panel--trends .organic-content-panel__trends-chart {\n    margin-inline: -10px;\n    width: calc(100% + 20px);\n    max-width: calc(100% + 20px);\n  }\n}\n\n@media (max-width: 640px) {\n  .organic-content-panel--trends .organic-content-panel__trends-chart {\n    margin-inline: 0;\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 1500px) {\n  .organic-content-report__chart-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .organic-content-report__chart-grid > .organic-content-panel:last-child {\n    grid-column: 1 / -1;\n  }\n}\n\n.organic-content-panel__trend-legend-swatch {\n  --legend-color: #6d28d9;\n  width: 22px;\n  height: 3px;\n  border-radius: 999px;\n  background: var(--legend-color);\n  position: relative;\n  display: inline-block;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    inset: 50% auto auto 50%;\n    width: 8px;\n    height: 8px;\n    border-radius: 999px;\n    border: 2px solid var(--legend-color);\n    background: #ffffff;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.organic-content-panel--table {\n  padding-bottom: 20px;\n  grid-column: 1 / -1;\n  overflow: visible;\n}\n\n.organic-content-panel--bar {\n  display: flex;\n  flex-direction: column;\n}\n\n.organic-content-panel--bar .organic-content-panel__title {\n  display: block;\n}\n\n.organic-content-panel--bar .organic-content-panel__title h3 {\n  display: inline;\n  margin-right: 6px;\n}\n\n.organic-content-panel__chart-fill {\n  flex: none;\n  min-height: 280px;\n}\n\n.organic-content-panel--bar .organic-bars__pagination {\n  flex-shrink: 0;\n  margin-top: 12px;\n}\n\n/* Post-level table: one card only — title + tooltip live inside DashboardDataTableCard (no outer organic-content-panel shell). */\n.organic-content-report__post-table-block {\n  width: 100%;\n  margin: 8px 0 20px;\n}\n\n.organic-content-report__post-table-block .dashboard-data-table-card .dashboard-data-table-panel__header .organic-content-panel__title h3 {\n  margin: 0;\n  color: #020617;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.organic-donut__legend--modern {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  padding-top: 8px;\n}\n\n.organic-post-details--modern {\n  border: 0;\n  border-radius: 0;\n  background: #ffffff;\n  overflow: visible;\n}\n\n/* Post tables use global dashboard-data-table styles; keep width for wide columns */\n.organic-post-details__table.dashboard-data-table.organic-post-details__table--modern {\n  min-width: 0;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.organic-post-details__col-post {\n  width: 42%;\n  min-width: 0;\n}\n\n.organic-post-details__col-action {\n  width: 164px;\n}\n\n.organic-post-details__th-post {\n  min-width: 0;\n}\n\n.organic-post-details__thumb {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: #eef2f7;\n  color: #0f172a;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.organic-post-details__thumb img,\n.organic-post-details__thumb video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.organic-post-details__thumb img.organic-post-details__thumb-fallback {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n// The Facebook fallback asset has its own baked-in whitespace border around\n// the badge, so filling the frame alone still shows it small; scaling up\n// crops past that whitespace instead (parent clips via `overflow: hidden`\n// above). The Instagram asset has no such border, so it stays at 100%.\n.organic-post-details__thumb img.organic-post-details__thumb-fallback--facebook {\n  transform: scale(1.6);\n}\n\n.organic-post-details__post-cell {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.organic-post-details__post-copy {\n  min-width: 0;\n  width: 100%;\n}\n\n.organic-post-details__caption-wrap {\n  position: relative;\n  display: block;\n  margin: 0 0 6px;\n}\n\n.organic-post-details__post-copy strong {\n  display: block;\n  margin: 0;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.35;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.organic-post-details__caption-tooltip {\n  display: none;\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 500;\n  width: 320px;\n  max-width: min(320px, calc(100vw - 40px));\n  padding: 10px 14px;\n  background: #ffffff;\n  border: 1px solid #d9e3f2;\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(14, 30, 62, 0.14);\n  font-size: 13px;\n  font-weight: 400;\n  color: #374151;\n  line-height: 1.5;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  pointer-events: none;\n}\n\n.organic-post-details__caption-wrap:hover .organic-post-details__caption-tooltip {\n  display: block;\n}\n\n/* `left: 0` above grows the tooltip rightward, which overruns into the sidebar when the\n   caption column sits near the RTL layout's trailing (right) edge — anchor from the right\n   instead so it grows back into the table. */\n[dir=\"rtl\"] .organic-post-details__caption-tooltip {\n  left: auto;\n  right: 0;\n}\n\n/* Flip tooltip upward for last 2 rows so it never clips at table bottom */\ntr:last-child .organic-post-details__caption-tooltip,\ntr:nth-last-child(2) .organic-post-details__caption-tooltip {\n  top: auto;\n  bottom: calc(100% + 6px);\n}\n\n.organic-post-details__tag-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n  min-width: 0;\n  width: 100%;\n}\n\n.organic-post-details__mini-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  max-width: min(100%, 320px);\n  min-height: 21px;\n  padding: 0 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.25;\n  border: 1px solid transparent;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  text-align: left;\n}\n\n.organic-post-details__mini-tag--platform {\n  color: #14532d;\n    background: #ecfdf3;\n    border-color: #a7f3d0;\n}\n\n.organic-post-details__mini-tag--type {\n color: #9a3412;\n    background: #fff7ed;\n    border-color: #fdba74;\n}\n\n.organic-post-details__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 18px 12px;\n  border-top: 1px solid #eef2f7;\n  background: #ffffff;\n  color: #64748b;\n  font-size: 12px;\n  margin-top: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.organic-post-details__action-cell {\n  white-space: nowrap;\n  text-align: center;\n}\n\n.organic-post-details__table-wrap.dashboard-data-table-scroll {\n  position: relative;\n  overflow-x: auto;\n  overflow-y: visible;\n}\n\n.organic-post-details__table--modern thead th:last-child,\n.organic-post-details__table--modern tbody td:last-child {\n  position: sticky;\n  right: 0;\n  z-index: 3;\n  background: #ffffff;\n  min-width: 164px;\n  padding-left: 22px;\n  padding-right: 32px;\n}\n\n.organic-post-details__table--modern thead th:last-child {\n  box-shadow: -1px 0 0 #e8edf4;\n}\n\n.organic-post-details__table--modern tbody td:last-child {\n  box-shadow: -1px 0 0 #eef2f7;\n}\n\n.organic-post-details__th-tooltip {\n  overflow: visible;\n}\n\n/**\n * Header cells must all start their label on the same line, whatever the label\n * length. Two-line labels (\"LIKES / REACTIONS\", \"ENGAGEMENT RATE\") used to make\n * the sort / (?) icons wrap onto their own row, and `vertical-align: middle`\n * then centred each cell's block independently — so short labels floated to the\n * middle of the row while long ones started at the top.\n *\n * Instead: top-align every header cell, keep label + ⇅ + (?) on one flex row,\n * and let only the label text itself wrap under the icons.\n */\n.organic-post-details--modern\n  .organic-post-details__table.dashboard-data-table\n  thead\n  th {\n  vertical-align: top;\n  // Shared 16px line box, so the plain-text (\"CONTENT\", \"LINK\") and tooltip\n  // headers put their first line at the same y.\n  line-height: 16px;\n}\n\n.organic-post-details__th-tooltip .dashboard-data-table__th-help-row,\n.organic-post-details__th-tooltip .dashboard-data-table__sort {\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  column-gap: 6px;\n  // 16px line box == the (?) trigger height, so the icons sit exactly on the\n  // first text line instead of on the middle of a wrapped label.\n  line-height: 16px;\n  white-space: normal;\n  overflow-wrap: break-word;\n  text-align: start;\n}\n\n.organic-post-details__th-tooltip .dashboard-data-table__sort > svg {\n  // 14px icon centred in the 16px line box.\n  margin-top: 1px;\n}\n\n.organic-post-details__th-tooltip:has(.definition-tooltip:hover),\n.organic-post-details__th-tooltip:has(.definition-tooltip:focus-within) {\n  z-index: 20;\n}\n\n.organic-post-details__action-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: center;\n  min-width: 86px;\n  height: 34px;\n  padding: 0 16px;\n  border: 1px solid #2c68ad;\n  border-radius: 8px;\n  background: #2c68ad;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n  text-decoration: none;\n}\n\n.organic-post-details__action-button:hover {\n  background: #1d4ed8;\n  color: #fff;\n  border-color: #1d4ed8;\n}\n\n.organic-post-details__action-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.organic-post-details__table-toolbar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-left: auto;\n  min-width: 0;\n}\n\n.organic-post-details__table-toolbar .dashboard-data-table-panel__search {\n  min-width: 320px;\n  width: min(42vw, 500px);\n  height: 44px;\n  flex: 0 1 500px;\n}\n\n.organic-post-details__export-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 44px;\n  padding: 0 12px;\n  border: 1px solid #d7e1ee;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.organic-post-details__export-button:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #bfd3ea;\n}\n\n.organic-post-details__export-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .organic-post-details__table-toolbar {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .organic-post-details__table-toolbar .dashboard-data-table-panel__search {\n    min-width: 0;\n    width: 100%;\n    flex: 1 1;\n  }\n}\n\n.organic-bars__value-label {\n  fill: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.organic-bars__pagination {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 12px;\n  padding: 8px 0 4px;\n}\n\n.organic-bars__pagination button {\n  width: 36px;\n  height: 36px;\n  border: 1px solid #e5e7eb;\n  border-radius: 50%;\n  background: #f8fafc;\n  color: #0f172a;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;\n}\n\n.organic-bars__pagination button:hover:not(:disabled) {\n  background: #eef2f7;\n}\n\n.organic-bars__pagination button:disabled {\n  opacity: 0.35;\n  background: #f3f4f6;\n  cursor: not-allowed;\n}\n\n.organic-bars__pagination span {\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.organic-post-details--modern .organic-post-details__table-wrap {\n  max-height: none;\n  overflow-x: auto;\n  overflow-y: visible;\n}\n\n.organic-post-details__pagination {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.organic-post-details__pagination button {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #475569;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  transition: opacity 0.16s ease, color 0.16s ease, background-color 0.16s ease, border-color 0.16s ease;\n}\n\n.organic-post-details__pagination button:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.organic-post-details__pagination button:disabled {\n  opacity: 0.35;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.organic-followers__fb-icon {\n  width: 38px;\n  height: 38px;\n  margin-bottom: 5px;\n  border-radius: $radius-round;\n  background: #0d468f;\n  color: $white;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  svg {\n    width: 28px;\n    height: 28px;\n    display: block;\n  }\n}\n\n.organic-followers__ig-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: $radius-lg;\n  border: none;\n  color: #0d468f;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.organic-followers-layout {\n  display: grid;\n  grid-template-columns: 340px minmax(0, 1fr) minmax(0, 1fr);\n  gap: 14px;\n  align-items: stretch;\n}\n\n.organic-followers-trend {\n  grid-column: 1 / -1;\n  min-height: 360px;\n\n  .recharts-surface {\n    direction: ltr;\n  }\n\n  &__toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    padding: 3px;\n    border: 1px solid #dbe4f0;\n    border-radius: 8px;\n    background: #f8fafc;\n  }\n\n  &__toggle-button {\n    min-width: 74px;\n    height: 30px;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: #5f748f;\n    font-size: 12px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;\n\n    &:hover {\n      color: #0d468f;\n    }\n\n    &--active {\n      background: #0d468f;\n      color: #ffffff;\n      box-shadow: 0 1px 3px rgba(13, 70, 143, 0.2);\n\n      &:hover {\n        color: #ffffff;\n      }\n    }\n  }\n\n  &__empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 280px;\n    color: #8a9bb8;\n    font-size: 14px;\n    font-weight: 600;\n  }\n}\n\n.organic-followers-layout__kpis {\n  display: grid;\n  grid-template-rows: auto auto;\n  gap: 10px;\n  align-content: start;\n  align-self: start;\n}\n\n.organic-instagram-layout {\n  display: grid;\n  grid-template-columns: 520px minmax(0, 1fr) minmax(0, 1fr);\n  gap: 14px;\n  align-items: stretch;\n}\n\n.organic-instagram-layout__left {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  gap: 14px;\n}\n\n.organic-instagram-layout__kpis {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.organic-followers-kpi {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: none;\n  padding: 18px 20px;\n  background: $white;\n  min-height: 188px;\n  position: relative;\n\n  h3 {\n    margin: 0;\n    color: #667085;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1.35;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    text-align: left;\n  }\n\n  .organic-content-panel__title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    margin-block: 0 6px;\n    margin-inline: 0 72px;\n\n    h3 {\n      margin: 0;\n      text-align: left;\n      line-height: 1.2;\n    }\n  }\n\n  &__badge {\n    position: absolute;\n    inset-inline-end: 20px;\n    top: 18px;\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    background: #f8fafc;\n    color: #356fb6;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: $font-size-lg;\n    line-height: 1;\n  }\n\n  &__content {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 92px;\n    align-items: center;\n    min-height: 96px;\n    gap: 10px;\n  }\n\n  &__meta {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    min-height: 0;\n    padding: 0;\n    min-width: 0;\n  }\n\n  &__value {\n    font-size: 24px;\n    line-height: 1.2;\n    color: #101828;\n    font-weight: 700;\n    margin-bottom: 8px;\n  }\n\n  &__period {\n    font-size: 12px;\n    color: #667085;\n    margin: 0;\n    line-height: 1.5;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    flex-wrap: wrap;\n    font-weight: 500;\n  }\n\n  &__period--unavailable {\n    color: #8a94a6;\n\n    .definition-tooltip__trigger {\n      color: inherit;\n    }\n  }\n\n  &__change {\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    font-weight: $font-weight-semibold;\n\n    &--positive {\n      color: #0d8a3e;\n    }\n\n    &--negative {\n      color: #c0392b;\n    }\n\n    &--neutral {\n      color: #64748b;\n    }\n  }\n\n  &__chart {\n    height: 74px;\n    align-self: center;\n    width: 100%;\n  }\n}\n\n.organic-followers-layout .organic-followers-kpi {\n  min-height: 172px;\n  height: 172px;\n  padding: 18px 20px;\n\n  .organic-content-panel__title {\n    margin: 0 60px 6px 0;\n  }\n\n  .organic-followers-kpi__content {\n    min-height: 92px;\n    grid-template-columns: minmax(0, 1fr) 88px;\n  }\n\n  .organic-followers-kpi__meta {\n    padding: 0;\n  }\n\n  .organic-followers-kpi__chart {\n    height: 70px;\n  }\n}\n\n.organic-followers-kpi--instagram {\n  min-height: 188px;\n}\n\n.organic-instagram-gender {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: none;\n  padding: 12px 10px 12px;\n  background: $white;\n  position: relative;\n\n  h3 {\n    margin: 0 0 8px;\n    color: #0d468f;\n    font-size: $font-size-md;\n    font-weight: $font-weight-bold;\n    text-align: center;\n  }\n\n  .organic-content-panel__title {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin: 0 0 8px;\n\n    h3 {\n      margin: 0;\n      line-height: 1.2;\n      text-align: left;\n    }\n\n    .organic-content-card__title-help-wrap {\n      transform: translateY(0);\n    }\n  }\n\n  &__content {\n    display: grid;\n    gap: 12px;\n  }\n\n  &__group {\n    display: grid;\n    grid-template-columns: 170px minmax(0, 1fr);\n    gap: 12px;\n    padding: 2px 6px;\n  }\n\n  &__summary {\n    display: grid;\n    grid-template-columns: 34px minmax(0, 1fr);\n    grid-template-rows: auto auto;\n    column-gap: 30px;\n    row-gap: 0;\n    align-items: center;\n    justify-items: start;\n    align-content: center;\n  }\n\n  &__icon {\n    color: #0d4f9d;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    grid-column: 1;\n    grid-row: 1 / span 2;\n\n    svg {\n      width: 26px;\n      height: 26px;\n      display: block;\n    }\n  }\n\n  &__percent {\n    color: #0d4f9d;\n    font-size: $font-size-xl;\n    line-height: 1;\n    font-weight: $font-weight-bold;\n    grid-column: 2;\n    grid-row: 1;\n    margin: 0;\n  }\n\n  &__period {\n    color: #325d88;\n    font-size: $font-size-sm;\n    line-height: 1.05;\n    grid-column: 2;\n    grid-row: 2;\n    margin: 0;\n    transform: translateY(-2px);\n  }\n\n  &__ages {\n    display: grid;\n    gap: 1px;\n  }\n\n  &__age-row {\n    display: grid;\n    grid-template-columns: 56px minmax(0, 1fr);\n    align-items: center;\n    gap: 8px;\n    min-height: 18px;\n    --followers-bar-color: #2b74e4;\n\n    &:nth-child(7n + 2) {\n      --followers-bar-color: #94d0b5;\n    }\n\n    &:nth-child(7n + 3) {\n      --followers-bar-color: #f6c15f;\n    }\n\n    &:nth-child(7n + 4) {\n      --followers-bar-color: #8d4fd3;\n    }\n\n    &:nth-child(7n + 5) {\n      --followers-bar-color: #5d97ee;\n    }\n\n    &:nth-child(7n + 6) {\n      --followers-bar-color: #5abf8b;\n    }\n\n    &:nth-child(7n) {\n      --followers-bar-color: #f0a84a;\n    }\n  }\n\n  &__age-label {\n    color: #5f6470;\n    font-size: $font-size-sm;\n    line-height: 1.05;\n    white-space: nowrap;\n  }\n\n  &__bar-track {\n    position: relative;\n    height: 10px;\n    background: transparent;\n  }\n\n  &__bar-fill {\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 2px;\n    background: var(--followers-bar-color);\n    display: block;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      right: -3px;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 8px;\n      height: 8px;\n      border-radius: $radius-round;\n      background: var(--followers-bar-color);\n    }\n  }\n\n  &__tooltip {\n    position: absolute;\n    right: 8px;\n    left: auto;\n    max-width: 250px;\n    z-index: 10;\n  }\n}\n\n.organic-followers-map {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: none;\n  padding: 12px 10px 10px;\n  background: $white;\n  display: grid;\n  grid-template-rows: auto 320px auto;\n  align-content: start;\n  min-height: 542px;\n\n  h3 {\n    margin: 0 0 8px;\n    color: #0d468f;\n    font-size: $font-size-md;\n    font-weight: $font-weight-bold;\n    text-align: center;\n  }\n\n  .organic-content-panel__title {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-bottom: 8px;\n\n    h3 {\n      margin: 0;\n      line-height: 1.2;\n    }\n  }\n\n  &__canvas {\n    border: 1px solid #e5e8ee;\n    background: #fafbfc;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #8993a1;\n    font-size: $font-size-sm;\n  }\n\n  &__footer {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 8px;\n    margin-top: 8px;\n    position: relative;\n\n    label {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      align-items: flex-start;\n      width: 110px;\n\n      span {\n        color: #0d468f;\n        font-size: $font-size-xs;\n        font-weight: $font-weight-bold;\n      }\n\n      input {\n        width: 94px;\n        height: 22px;\n        border: 1px solid #757575;\n        padding: 0 6px;\n        font-size: $font-size-sm;\n      }\n    }\n\n    ul {\n      margin: 0;\n      padding: 0;\n      list-style: none;\n      max-height: 180px;\n      overflow-y: auto;\n      border: 1px solid #eceff4;\n      width: 100%;\n    }\n\n    li {\n      font-size: $font-size-sm;\n      color: #4e5865;\n      padding: 7px 8px;\n      border-bottom: 1px solid #f0f2f6;\n    }\n  }\n\n  &__count-control {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    width: 110px;\n  }\n\n  &__range {\n    width: 96px;\n    height: 12px;\n    margin: 0;\n    accent-color: #b9bec7;\n  }\n\n  &__range--all {\n    accent-color: #3f3f46;\n  }\n\n  &__change--up {\n    color: #15803d;\n    font-size: 11px;\n    margin-left: 6px;\n  }\n\n  &__change--down {\n    color: $color-b91c1c;\n    font-size: 11px;\n    margin-left: 6px;\n  }\n\n  &__ranked {\n    max-height: none !important;\n    overflow: visible !important;\n\n    li {\n      display: grid;\n      grid-template-columns: 160px minmax(0, 1fr);\n      align-items: center;\n      gap: 10px;\n      padding: 6px 8px;\n      cursor: default;\n      --followers-bar-color: #2b74e4;\n\n      &:nth-child(7n + 2) {\n        --followers-bar-color: #94d0b5;\n      }\n\n      &:nth-child(7n + 3) {\n        --followers-bar-color: #f6c15f;\n      }\n\n      &:nth-child(7n + 4) {\n        --followers-bar-color: #8d4fd3;\n      }\n\n      &:nth-child(7n + 5) {\n        --followers-bar-color: #5d97ee;\n      }\n\n      &:nth-child(7n + 6) {\n        --followers-bar-color: #5abf8b;\n      }\n\n      &:nth-child(7n) {\n        --followers-bar-color: #f0a84a;\n      }\n\n      p {\n        margin: 0;\n        font-size: $font-size-sm;\n        color: #3b4654;\n        line-height: 1.2;\n      }\n    }\n  }\n\n  &__rank-metric {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto auto;\n    align-items: center;\n    gap: 4px;\n\n    > span:first-of-type {\n      display: block;\n      height: 10px;\n      background: var(--followers-bar-color);\n      min-width: 2px;\n    }\n\n    strong {\n      font-size: $font-size-sm;\n      color: #2f2f2f;\n      font-weight: 500;\n      line-height: 1;\n      white-space: nowrap;\n    }\n\n    .organic-followers-map__change--up,\n    .organic-followers-map__change--down {\n      margin-left: 2px;\n    }\n  }\n\n  &__tooltip {\n    position: absolute;\n    right: 6px;\n    left: auto;\n    max-width: 250px;\n    z-index: 12;\n    pointer-events: none;\n  }\n}\n\n.organic-instagram-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  align-items: stretch;\n}\n\n.organic-instagram-layout__top {\n  display: grid;\n  grid-template-columns: 360px minmax(0, 1fr);\n  gap: 24px;\n  align-items: stretch;\n}\n\n.organic-instagram-layout__kpis {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n}\n\n.organic-instagram-layout .organic-followers-kpi--instagram {\n  min-height: 150px;\n  height: 150px;\n  padding: 24px 28px;\n  border-color: #dbe4f0;\n  border-radius: 14px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .organic-content-panel__title {\n    margin-block: 0 4px;\n    margin-inline: 0 74px;\n  }\n\n  .organic-followers-kpi__badge {\n    top: 24px;\n    inset-inline-end: 28px;\n    width: 52px;\n    height: 52px;\n    border-radius: 10px;\n    background: #eef4fb;\n    color: #2e6fb9;\n  }\n\n  .organic-followers-kpi__content {\n    display: block;\n    min-height: 0;\n  }\n\n  .organic-followers-kpi__value {\n    font-size: 30px;\n    line-height: 1.05;\n    margin-bottom: 22px;\n  }\n\n  .organic-followers-kpi__period {\n    font-size: 14px;\n    color: #8ba0bb;\n  }\n}\n\n.organic-followers-trend--instagram {\n  grid-column: auto;\n  min-height: 326px;\n  padding: 28px 30px 16px;\n  border-color: #dbe4f0;\n  border-radius: 14px;\n\n  .organic-content-panel__header {\n    margin-bottom: 10px;\n  }\n\n  .organic-content-panel__title h3 {\n    color: #0f172a;\n    font-size: 18px;\n    font-weight: 700;\n    text-align: left;\n  }\n\n  .organic-followers-trend__toggle {\n    border: 0;\n    border-radius: 10px;\n    background: #f0f5fb;\n    padding: 4px;\n  }\n\n  .organic-followers-trend__toggle-button {\n    min-width: 70px;\n    height: 32px;\n    border-radius: 8px;\n    color: #6b7f98;\n    font-size: 12px;\n  }\n\n  .organic-followers-trend__toggle-button--active {\n    background: #ffffff;\n    color: #0f172a;\n    box-shadow: 0 2px 7px rgba(15, 23, 42, 0.08);\n  }\n}\n\n.organic-instagram-gender {\n  padding: 28px 34px 36px;\n  border-color: #dbe4f0;\n  border-radius: 14px;\n\n  .organic-content-panel__title {\n    justify-content: flex-start;\n    margin: 0 0 22px;\n\n    h3 {\n      color: #0f172a;\n      font-size: 18px;\n      font-weight: 700;\n      text-align: left;\n    }\n  }\n\n  &__content {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 16px;\n  }\n\n  &__group {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 14px;\n    min-height: 430px;\n    padding: 22px 26px 20px;\n    border: 1px solid #dbe4f0;\n    border-radius: 12px;\n    background: #ffffff;\n  }\n\n  &__summary {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n    text-align: center;\n\n    h4 {\n      margin: 0;\n      color: #111827;\n      font-size: 16px;\n      font-weight: 700;\n      line-height: 1.2;\n    }\n  }\n\n  &__percent {\n    color: #2f6fb8;\n    font-size: 28px;\n    line-height: 1;\n    font-weight: 800;\n    margin: 0;\n  }\n\n  &__period {\n    color: #8ba0bb;\n    font-size: 14px;\n    line-height: 1.2;\n    transform: none;\n  }\n\n  &__donut {\n    width: 220px;\n    max-width: 100%;\n    height: 180px;\n    margin: 0 auto;\n  }\n\n  &__legend {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 26px;\n    row-gap: 14px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    li {\n      display: grid;\n      grid-template-columns: 14px minmax(0, 1fr) auto;\n      align-items: center;\n      gap: 8px;\n      color: #475569;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 1.2;\n      min-width: 0;\n    }\n\n    span:not(.organic-instagram-gender__legend-swatch) {\n      min-width: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    strong {\n      color: #475569;\n      font-size: 14px;\n      font-weight: 800;\n      white-space: nowrap;\n    }\n  }\n\n  &__legend-swatch {\n    width: 14px;\n    height: 14px;\n    border-radius: 3px;\n    display: inline-block;\n  }\n}\n\n.organic-instagram-layout__geo {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n}\n\n.organic-instagram-ranked {\n  min-height: 540px;\n  padding: 34px 34px 38px;\n  border-color: #dbe4f0;\n  border-radius: 14px;\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 18px;\n    margin-bottom: 34px;\n  }\n\n  .organic-content-panel__title {\n    justify-content: flex-start;\n    margin: 0;\n\n    h3 {\n      color: #0f172a;\n      font-size: 18px;\n      font-weight: 700;\n      line-height: 1;\n      text-align: left;\n    }\n\n    // Cancel the global 1px nudge on the trigger button — it's tuned for\n    // smaller default headings and sits too low next to this 18px bold h3.\n    .definition-tooltip__trigger {\n      transform: translateY(0);\n    }\n  }\n\n  &__control {\n    display: inline-flex;\n    align-items: center;\n    gap: 16px;\n    color: #111827;\n    font-size: 16px;\n    font-weight: 500;\n    white-space: nowrap;\n\n    select {\n      width: 86px;\n      height: 44px;\n      border: 1px solid #cbd9ea;\n      border-radius: 10px;\n      background: #ffffff;\n      color: #111827;\n      padding: 0 32px 0 16px;\n      font-size: 16px;\n      font-weight: 500;\n      outline: none;\n      appearance: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2.2 4.5L6 8.2l3.8-3.7' fill='none' stroke='%23111827' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n      background-repeat: no-repeat;\n      background-position: right 12px center;\n      background-size: 12px 12px;\n    }\n  }\n\n  &__list {\n    display: grid;\n    gap: 18px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &__item {\n    display: grid;\n    grid-template-columns: 164px minmax(0, 1fr) 72px;\n    align-items: center;\n    gap: 12px;\n    min-height: 20px;\n\n    strong {\n      color: #0f172a;\n      font-size: 14px;\n      font-weight: 800;\n      text-align: right;\n      white-space: nowrap;\n    }\n  }\n\n  &__name {\n    color: #334155;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.2;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__bar-track {\n    display: block;\n    height: 18px;\n    border-radius: 4px;\n    background: #f0f5fb;\n    overflow: hidden;\n  }\n\n  &__bar-fill {\n    display: block;\n    height: 100%;\n    border-radius: 4px;\n  }\n\n  &__empty {\n    display: flex;\n    min-height: 320px;\n    align-items: center;\n    justify-content: center;\n    color: #8ba0bb;\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  &__tooltip {\n    position: fixed;\n    z-index: 40;\n    max-width: 260px;\n    pointer-events: none;\n  }\n}\n\n.organic-facebook-followers-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  align-items: stretch;\n}\n\n.organic-facebook-followers-layout__top {\n  display: grid;\n  grid-template-columns: 360px minmax(0, 1fr);\n  gap: 24px;\n  align-items: stretch;\n}\n\n.organic-facebook-followers-layout__kpis {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n}\n\n.organic-facebook-followers-layout .organic-followers-kpi--facebook-modern {\n  min-height: 150px;\n  height: 150px;\n  padding: 24px 28px;\n  border-color: #dbe4f0;\n  border-radius: 14px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .organic-content-panel__title {\n    margin-block: 0 4px;\n    margin-inline: 0 74px;\n  }\n\n  .organic-followers-kpi__badge {\n    top: 24px;\n    inset-inline-end: 28px;\n    width: 52px;\n    height: 52px;\n    border-radius: 10px;\n    background: #eef4fb;\n    color: #2e6fb9;\n  }\n\n  .organic-followers-kpi__content {\n    display: block;\n    min-height: 0;\n  }\n\n  .organic-followers-kpi__value {\n    font-size: 30px;\n    line-height: 1.05;\n    margin-bottom: 22px;\n  }\n\n  .organic-followers-kpi__period {\n    font-size: 14px;\n    color: #8ba0bb;\n  }\n}\n\n.organic-followers-trend--modern {\n  grid-column: auto;\n  min-height: 326px;\n  padding: 28px 30px 16px;\n  border-color: #dbe4f0;\n  border-radius: 14px;\n\n  .organic-content-panel__header {\n    margin-bottom: 10px;\n  }\n\n  .organic-content-panel__title h3 {\n    color: #0f172a;\n    font-size: 18px;\n    font-weight: 700;\n    text-align: left;\n  }\n\n  .organic-followers-trend__toggle {\n    border: 0;\n    border-radius: 10px;\n    background: #f0f5fb;\n    padding: 4px;\n  }\n\n  .organic-followers-trend__toggle-button {\n    min-width: 70px;\n    height: 32px;\n    border-radius: 8px;\n    color: #6b7f98;\n    font-size: 12px;\n  }\n\n  .organic-followers-trend__toggle-button--active {\n    background: #ffffff;\n    color: #0f172a;\n    box-shadow: 0 2px 7px rgba(15, 23, 42, 0.08);\n  }\n}\n\n.organic-facebook-followers-layout__geo {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n}\n\n.organic-followers-ranked {\n  min-height: 540px;\n  padding: 34px 34px 38px;\n  border-color: #dbe4f0;\n  border-radius: 14px;\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 18px;\n    margin-bottom: 34px;\n  }\n\n  .organic-content-panel__title {\n    justify-content: flex-start;\n    margin: 0;\n\n    h3 {\n      color: #0f172a;\n      font-size: 18px;\n      font-weight: 700;\n      line-height: 1;\n      text-align: left;\n    }\n\n    // Cancel the global 1px nudge on the trigger button — it's tuned for\n    // smaller default headings and sits too low next to this 18px bold h3.\n    .definition-tooltip__trigger {\n      transform: translateY(0);\n    }\n  }\n\n  &__control {\n    display: inline-flex;\n    align-items: center;\n    gap: 16px;\n    color: #111827;\n    font-size: 16px;\n    font-weight: 500;\n    white-space: nowrap;\n\n    select {\n      width: 86px;\n      height: 44px;\n      border: 1px solid #cbd9ea;\n      border-radius: 10px;\n      background: #ffffff;\n      color: #111827;\n      padding: 0 32px 0 16px;\n      font-size: 16px;\n      font-weight: 500;\n      outline: none;\n      appearance: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2.2 4.5L6 8.2l3.8-3.7' fill='none' stroke='%23111827' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n      background-repeat: no-repeat;\n      background-position: right 12px center;\n      background-size: 12px 12px;\n    }\n  }\n\n  &__list {\n    display: grid;\n    gap: 18px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &__item {\n    display: grid;\n    grid-template-columns: 164px minmax(0, 1fr) 72px;\n    align-items: center;\n    gap: 12px;\n    min-height: 20px;\n\n    strong {\n      color: #0f172a;\n      font-size: 14px;\n      font-weight: 800;\n      text-align: right;\n      white-space: nowrap;\n    }\n  }\n\n  &__name {\n    color: #334155;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.2;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__bar-track {\n    display: block;\n    height: 18px;\n    border-radius: 4px;\n    background: #f0f5fb;\n    overflow: hidden;\n  }\n\n  &__bar-fill {\n    display: block;\n    height: 100%;\n    border-radius: 4px;\n  }\n\n  &__empty {\n    display: flex;\n    min-height: 320px;\n    align-items: center;\n    justify-content: center;\n    color: #8ba0bb;\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  &__tooltip {\n    position: fixed;\n    z-index: 40;\n    max-width: 260px;\n    pointer-events: none;\n  }\n}\n\n.organic-kpi-card {\n  border: 1px solid #c5d8ee;\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  padding: 10px 10px 8px;\n  background: $white;\n  min-height: 172px;\n\n  h3 {\n    margin: 0 0 6px;\n    color: #0d468f;\n    font-size: $font-size-md;\n    font-weight: $font-weight-bold;\n    margin-top: 20px;\n  }\n\n  &__content {\n    display: grid;\n    grid-template-columns: 45% 55%;\n    align-items: end;\n    min-height: 138px;\n    gap: 4px;\n  }\n\n  &__meta {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    min-height: 106px;\n    padding: 0 8px 10px 26px;\n  }\n\n  &__value {\n    font-size: $font-size-xl;\n    line-height: 1;\n    color: #124a94;\n    font-weight: bolder;\n    margin-bottom: 4px;\n  }\n\n  &__period {\n    font-size: $font-size-xs;\n    color: #325d88;\n    margin-bottom: 0;\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__change {\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    font-weight: $font-weight-semibold;\n\n    &--positive {\n      color: #0d8a3e;\n    }\n\n    &--negative {\n      color: #c0392b;\n    }\n  }\n\n  &__chart {\n    height: 100px;\n    align-self: end;\n\n    .recharts-wrapper,\n    .recharts-surface,\n    .recharts-responsive-container {\n      overflow: visible !important;\n    }\n  }\n}\n\n.organic-engagements {\n  border: 1px solid #bfd4eb;\n  border-radius: 10px;\n  overflow: hidden;\n  background: $white;\n  max-width: 360px;\n  height: 100%;\n\n  h3 {\n    margin: 0;\n    padding: 10px 12px;\n    text-align: center;\n    color: #0d468f;\n    font-size: $font-size-md;\n    font-weight: $font-weight-bold;\n    border-bottom: 1px solid #d6d9de;\n  }\n\n  &__rows {\n    position: relative;\n    padding-bottom: 10px;\n  }\n\n  &__row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: center;\n    min-height: 40px;\n    padding: 6px 16px;\n    font-size: $font-size-sm;\n    color: #2f2f2f;\n    cursor: default;\n\n    span {\n      text-align: center;\n      padding: 0 8px;\n    }\n\n    strong {\n      color: #4d4d4d;\n      font-size: $font-size-sm;\n      font-weight: 500;\n      line-height: 1;\n      min-width: 70px;\n      text-align: right;\n    }\n\n    &--alt {\n      background: #edf0f6;\n    }\n  }\n\n  &__tooltip {\n    position: absolute;\n    right: 12px;\n    top: 46px;\n    z-index: 10;\n  }\n}\n\n.organic-visuals {\n  border: 1px solid #bfd4eb;\n  border-radius: 10px;\n  background: $white;\n  padding: 10px 12px;\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);\n  gap: 16px;\n}\n\n.organic-donut {\n  &__header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 2px;\n\n    h3 {\n      margin: 0;\n      color: #0d468f;\n      font-size: $font-size-md;\n      font-weight: $font-weight-bold;\n    }\n  }\n\n  &__title-wrap {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__toggle {\n    width: auto;\n    height: auto;\n    border: 0;\n    background: transparent;\n    color: #2f66ab;\n    cursor: pointer;\n    padding: 1px 0 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  &__toggle-icon {\n    display: inline-block;\n    width: 11px;\n    height: 11px;\n    border-right: 2px solid #2f66ab;\n    border-top: 2px solid #2f66ab;\n    transform: rotate(45deg);\n    transition: transform 0.2s ease;\n  }\n\n  &__toggle--reverse .organic-donut__toggle-icon {\n    transform: rotate(-135deg);\n  }\n\n  &__legend {\n    list-style: none;\n    margin: 0;\n    padding: 6px 0 0;\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 6px 10px;\n\n    li {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      min-width: 0;\n    }\n\n    span {\n      width: 9px;\n      height: 9px;\n      border-radius: 1px;\n      flex-shrink: 0;\n    }\n\n    p {\n      margin: 0;\n      font-size: $font-size-sm;\n      color: #1f1f1f;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .recharts-wrapper {\n    margin-top: 2px;\n  }\n}\n\n.organic-bars {\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 6px;\n\n    h3 {\n      margin: 0;\n      color: #0d468f;\n      font-size: $font-size-md;\n      font-weight: $font-weight-bold;\n    }\n\n  }\n\n  &__select-wrap {\n    position: relative;\n    width: 184px;\n  }\n\n  &__select {\n    width: 100%;\n  }\n\n  .recharts-cartesian-axis-line,\n  .recharts-cartesian-axis-tick-line {\n    stroke: transparent;\n  }\n\n  &__pagination {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    width: 100%;\n    margin-top: 8px;\n    color: #64748b;\n    font-size: 12px;\n  }\n\n  &__pagination button {\n    width: 32px;\n    height: 32px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #ffffff;\n    color: #475569;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    transition: opacity 0.16s ease, color 0.16s ease, background-color 0.16s ease, border-color 0.16s ease;\n  }\n\n  &__pagination button:hover:not(:disabled) {\n    background: #f8fafc;\n  }\n\n  &__pagination button:disabled {\n    opacity: 0.35;\n    color: #94a3b8;\n    cursor: not-allowed;\n  }\n}\n\n.organic-custom-select {\n  position: relative;\n  width: 100%;\n}\n\n.organic-custom-select__trigger {\n  width: 100%;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 0 16px;\n  border: 1px solid #ccd6e3;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.organic-custom-select__trigger:hover {\n  border-color: #c7d1df;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.organic-custom-select__trigger--open {\n  border-color: #cfd8e3;\n  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18);\n}\n\n.organic-custom-select__trigger-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.organic-custom-select__trigger-icon {\n  width: 16px;\n  height: 16px;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.organic-custom-select__dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  z-index: 30;\n  width: 100%;\n  max-height: 420px;\n  overflow-y: auto;\n  padding: 6px;\n  border: 1px solid #e6edf7;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n}\n\n.organic-custom-select__option {\n  display: grid;\n  grid-template-columns: 20px minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 40px;\n  padding: 10px 12px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #0f172a;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.organic-custom-select__option:hover {\n  background: #f2f2f2;\n}\n\n.organic-custom-select__option--active {\n  background: #e4e4e4;\n  color: #1f1f1f;\n  font-weight: 600;\n}\n\n.organic-custom-select__option-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: #111827;\n}\n\n.organic-custom-select__option-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.organic-post-details {\n  border: none;\n  border-radius: 10px;\n  background: $white;\n  overflow: hidden;\n\n  &__header {\n    border-bottom: 1px solid #d6d9de;\n    padding: 8px 12px;\n    text-align: center;\n\n    h3 {\n      margin: 0;\n      color: #0d468f;\n      font-size: $font-size-md;\n      font-weight: $font-weight-bold;\n    }\n  }\n\n  &__table-wrap {\n    overflow-x: auto;\n    max-height: 420px;\n    overflow-y: auto;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    min-width: 1260px;\n    table-layout: fixed;\n\n    th {\n      position: sticky;\n      top: 0;\n      z-index: 2;\n      background: $white;\n      color: #4b4f58;\n      font-size: $font-size-sm;\n      font-weight: $font-weight-semibold;\n      padding: 10px 8px;\n      text-align: left;\n      border-bottom: 1px solid #e3e7ed;\n      white-space: nowrap;\n      box-sizing: border-box;\n    }\n\n    td {\n      padding: 20px 20px;\n    font-size: 14px;\n    line-height: 1.35;\n    color: #0f172a;\n    vertical-align: middle;\n    background: #ffffff;\n    text-align: left;\n    }\n\n    tr:nth-child(even) td {\n      background: $white;\n    }\n  }\n\n  &__col-caption {\n    width: 28%;\n  }\n\n  &__col-post-type {\n    width: 9%;\n  }\n\n  &__col-engagement {\n    width: 10%;\n  }\n\n  &__col-metric {\n    width: 8.83%;\n  }\n\n  &__caption {\n    text-align: left !important;\n    line-height: 1.25;\n    color: #5f6470 !important;\n    border-right: 1px solid #e3e7ed;\n  }\n\n  &__post-type {\n    text-align: left;\n    border-right: 1px solid #e3e7ed;\n  }\n\n  &__type-text {\n    color: #616877;\n    font-size: 13px;\n    line-height: 1.2;\n  }\n\n  &__th-caption {\n    text-align: left !important;\n    padding-left: 8px !important;\n    border-right: 1px solid #e3e7ed;\n  }\n\n  &__th-post-type,\n  &__th-engagement {\n    text-align: left !important;\n  }\n\n  &__th-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    white-space: nowrap;\n    cursor: default;\n    user-select: none;\n  }\n\n  &__header-icon {\n    display: inline-flex;\n    align-items: center;\n    color: #5f6470;\n    line-height: 1;\n  }\n\n  &__th-label--sortable {\n    cursor: pointer;\n    transition: color 0.16s ease;\n\n    &:hover {\n      color: #0d468f;\n    }\n  }\n\n  &__th-label--active {\n    color: #0d468f;\n  }\n\n  &__sort-icon {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    color: #6d7788;\n    transform: translateY(-1px);\n    transition: color 0.16s ease;\n  }\n\n  &__sort-icon--active {\n    color: #0d468f;\n  }\n\n  &__sort-bars {\n    display: inline-flex;\n    flex-direction: column;\n    gap: 1px;\n\n    i {\n      display: block;\n      height: 1px;\n      background: #6d7788;\n      width: 8px;\n    }\n\n    i:nth-child(2) {\n      width: 6px;\n    }\n\n    i:nth-child(3) {\n      width: 4px;\n    }\n  }\n\n  &__sort-icon--desc .organic-post-details__sort-bars {\n    i:nth-child(1) {\n      width: 4px;\n    }\n\n    i:nth-child(2) {\n      width: 6px;\n    }\n\n    i:nth-child(3) {\n      width: 8px;\n    }\n  }\n\n  &__pill {\n    display: inline-grid;\n    place-items: center;\n    align-items: center;\n    justify-content: center;\n    min-width: 68px;\n    min-height: 40px;\n    padding: 0 10px;\n    border-radius: 14px;\n    background: #0e4f9a;\n    color: $white;\n    font-size: $font-size-md;\n    font-weight: $font-weight-semibold;\n    line-height: 1;\n  }\n\n  &__pill--secondary {\n    background: #2f6eb9;\n  }\n\n  &__metric {\n    display: inline-grid;\n    place-items: center;\n    align-items: center;\n    justify-content: center;\n    min-width: 68px;\n    min-height: 40px;\n    padding: 0 10px;\n    border-radius: 14px;\n    background: #f1f2f4;\n    color: #2f2f2f;\n    font-size: $font-size-md;\n    font-weight: $font-weight-semibold;\n    line-height: 1;\n  }\n\n  &__metric--blue {\n    background: #6e97c9;\n    color: $white;\n  }\n}\n\n/* Force the post-level modern table to use the shared paid-media table mechanics, not the legacy organic table shell above. */\n.organic-post-details--modern .organic-post-details__table.dashboard-data-table {\n  // Percentage column widths squeezed the metric columns below the width their\n  // header (label + sort icon + (?) trigger) needs, so headers overlapped the\n  // next cell. Explicit px columns + fit-content let the wrapper scroll\n  // horizontally instead.\n  min-width: fit-content;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.organic-post-details--modern .organic-post-details__col-post {\n  width: 320px;\n}\n\n// Wide enough for the longest wrapped label word plus the ⇅ and (?) icons on\n// the same line (e.g. \"REACTIONS ⇅ ?\"), so a header never overlaps its\n// neighbour now that the help row no longer wraps.\n.organic-post-details--modern .organic-post-details__col-metric {\n  width: 152px;\n}\n\n.organic-post-details--modern .organic-post-details__table.dashboard-data-table th {\n  padding: 21px 20px;\n  border-bottom: 1px solid #e8edf4;\n  background: #ffffff;\n}\n\n.organic-post-details--modern\n  .organic-post-details__table.dashboard-data-table\n  th.organic-post-details__th-tooltip {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.organic-post-details--modern .organic-post-details__table.dashboard-data-table td {\n  padding: 20px 20px;\n}\n\n.organic-post-details--modern .organic-post-details__pager.table-page-pagination {\n  min-height: 78px;\n  padding: 16px 18px;\n  border-top: 1px solid #eef2f7;\n  background: #ffffff;\n  margin-top: 0;\n}\n\n.organic-tooltip {\n  background: #f6f6f6;\n  border: 1px solid #bfbfbf;\n  box-shadow: 2px 3px 0 rgba(0, 0, 0, 0.18);\n  padding: 8px 10px;\n  min-width: 140px;\n\n  &__row {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    color: #585858;\n    font-size: $font-size-sm;\n\n    strong {\n      color: #2d2d2d;\n      font-size: $font-size-sm;\n      font-weight: $font-weight-bold;\n    }\n  }\n\n  &--kpi {\n    min-width: 250px;\n    display: flex;\n    padding: 0;\n    border: 1px solid #cfd8e6;\n    border-radius: $radius-md;\n    background: $white;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.16);\n  }\n\n  &__bar {\n    width: 5px;\n    background: #2b74e4;\n    border-radius: 8px 0 0 8px;\n    flex-shrink: 0;\n  }\n\n  &__content {\n    width: 100%;\n    padding: 12px 16px 11px;\n  }\n\n  &__kpi-title {\n    color: #2f5f9f;\n    font-size: 31px;\n    font-weight: $font-weight-bold;\n    line-height: 1.2;\n  }\n\n  &__kpi-value {\n    color: #1d4f91;\n    font-size: $font-size-md;\n    font-weight: $font-weight-bold;\n    line-height: 1.2;\n    margin-top: 1px;\n  }\n\n  &__kpi-month {\n    color: #2f5f9f;\n    font-size: $font-size-md;\n    line-height: 1.2;\n  }\n\n  &__divider {\n    height: 1px;\n    background: #b8c7dd;\n    margin: 8px 0;\n  }\n\n  &__mom-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: nowrap;\n  }\n\n  &__mom-label {\n    color: #4d6f9c;\n    font-size: 30px;\n    line-height: 1.1;\n  }\n\n  &__mom-value {\n    font-size: 30px;\n    line-height: 1.1;\n    font-weight: $font-weight-bold;\n  }\n\n  &__mom-value--positive {\n    color: #1b8e4a;\n  }\n\n  &__mom-value--negative {\n    color: $color-d93025;\n  }\n\n  &__meta-line {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: nowrap;\n  }\n\n  &__meta-label {\n    color: #4d6f9c;\n    font-size: $font-size-sm;\n    line-height: 1.2;\n  }\n\n  &__meta-value {\n    color: #1d4f91;\n    font-size: $font-size-sm;\n    line-height: 1.2;\n    font-weight: $font-weight-bold;\n  }\n}\n\n.organic-tabs-dashboard .recharts-tooltip-wrapper {\n  z-index: 25;\n  pointer-events: none;\n}\n\n.organic-kpi-card .recharts-tooltip-wrapper {\n  margin-top: -18px;\n}\n\n.organic-tabs-dashboard .recharts-default-tooltip {\n  background: transparent !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n\n@media (max-width: 1024px) {\n  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__actions {\n    margin-inline-start: auto;\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__actions--filters {\n    grid-template-columns: max-content;\n    justify-content: end;\n    justify-items: stretch;\n  }\n\n  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__control,\n  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__control--wide {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__control--wide {\n    width: max-content;\n  }\n\n  .organic-content-report__section-header.dashboard-section-header .dashboard-section-header__control:not(.dashboard-section-header__control--wide) {\n    width: calc(200px + 12px + 200px);\n  }\n\n  .organic-content-report__section-header .organic-content-report__caption-select {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1150px) {\n  .organic-tabs-dashboard:has(.organic-content-report) {\n    display: block;\n  }\n\n  .organic-tabs-dashboard__tabs {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 14px;\n  }\n\n  .organic-content-report {\n    display: block;\n  }\n\n  .organic-content-report__toolbar {\n    grid-template-columns: 1fr;\n    grid-column: auto;\n    justify-items: stretch;\n    gap: 10px;\n    margin-top: 12px;\n  }\n\n  .organic-content-report__toolbar-field,\n  .organic-content-report__toolbar-field--range,\n  .organic-content-report__toolbar-field--caption {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .organic-content-report__toolbar-field--caption {\n    margin-left: 0;\n  }\n\n  .organic-content-report__toolbar-field--caption > select {\n    width: 100%;\n  }\n\n  .organic-tabs-dashboard__section-header-main,\n  .organic-tabs-dashboard__section-header-picker {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .organic-tabs-dashboard__section-header-picker {\n    justify-content: flex-start;\n  }\n\n  .organic-tabs-dashboard__section-header-picker.dashboard-filter-toolbar {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .organic-tabs-dashboard__section-header-picker .organic-range-picker,\n  .organic-tabs-dashboard__section-header-picker .organic-range-picker__control {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n@media (max-width: 1100px) {\n  .organic-content-report__kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .organic-content-report__engagement-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .organic-content-report__chart-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-tabs-dashboard__kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .organic-tabs-dashboard__bottom {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-visuals {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-followers-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-followers-layout__kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    grid-template-rows: none;\n  }\n\n  .organic-instagram-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-facebook-followers-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-instagram-layout__top,\n  .organic-instagram-layout__geo,\n  .organic-facebook-followers-layout__top,\n  .organic-facebook-followers-layout__geo {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-instagram-gender__content {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .organic-tabs-dashboard__section-header--followers {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .organic-tabs-dashboard__section-header-picker {\n    width: 100%;\n    margin-left: 0;\n    justify-content: flex-start;\n  }\n\n  .organic-tabs-dashboard__section-header-picker .organic-range-picker,\n  .organic-tabs-dashboard__section-header-picker .organic-range-picker__control {\n    width: 100%;\n    max-width: none;\n  }\n\n  .organic-tabs-dashboard:has(.organic-content-report) {\n    display: block;\n  }\n\n  .organic-tabs-dashboard__tabs {\n    //display: grid;\n    grid-template-columns: 1fr;\n    width: 100%;\n  }\n\n  .organic-content-report {\n    display: block;\n  }\n\n  .organic-content-report__toolbar {\n    grid-template-columns: 1fr;\n    margin-top: 18px;\n    gap: 10px;\n  }\n\n  .organic-content-report__toolbar-field,\n  .organic-content-report__toolbar-field--range,\n  .organic-content-report__toolbar-field--caption {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .organic-range-picker,\n  .organic-range-picker__control {\n    width: 100%;\n    max-width: none;\n    justify-content: end;\n  }\n\n  .organic-content-report__toolbar-field--caption > select {\n    width: 100%;\n  }\n\n  .organic-content-report__kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-content-report__engagement-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .organic-tabs-dashboard {\n    width: 100%;\n\n    &__tabs {\n      flex-wrap: wrap;\n    }\n\n    &__tab {\n      font-size: $font-size-sm;\n      padding: 5px 8px;\n    }\n\n    &__section-header h2 {\n      font-size: 24px;\n    }\n\n    &__filters {\n      justify-content: flex-start;\n      flex-wrap: wrap;\n      gap: 10px;\n\n      label {\n        min-width: 160px;\n      }\n\n      label:first-child {\n        min-width: 220px;\n      }\n    }\n\n    &__kpis {\n      grid-template-columns: 1fr;\n      gap: 10px;\n    }\n  }\n\n  .organic-engagements {\n    max-width: 100%;\n  }\n\n  .organic-engagements__tooltip {\n    display: none;\n  }\n\n  .organic-kpi-card__content {\n    grid-template-columns: 1fr;\n    min-height: 0;\n    gap: 4px;\n  }\n\n  .organic-kpi-card__meta {\n    min-height: 0;\n    padding-bottom: 0;\n  }\n\n  .organic-kpi-card__chart {\n    height: 64px;\n  }\n\n  .organic-followers-layout__kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-instagram-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-instagram-layout__kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-instagram-layout__top,\n  .organic-instagram-layout__geo,\n  .organic-facebook-followers-layout__top,\n  .organic-facebook-followers-layout__geo {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .organic-facebook-followers-layout__kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-instagram-layout .organic-followers-kpi--instagram {\n    height: auto;\n    min-height: 150px;\n  }\n\n  .organic-facebook-followers-layout .organic-followers-kpi--facebook-modern {\n    height: auto;\n    min-height: 150px;\n  }\n\n  .organic-instagram-gender {\n    padding: 22px 18px;\n  }\n\n  .organic-instagram-gender__group {\n    padding: 20px 16px;\n  }\n\n  .organic-instagram-gender__legend {\n    grid-template-columns: 1fr;\n  }\n\n  .organic-instagram-ranked {\n    padding: 24px 18px;\n    min-height: 0;\n  }\n\n  .organic-followers-ranked {\n    padding: 24px 18px;\n    min-height: 0;\n  }\n\n  .organic-instagram-ranked__header,\n  .organic-followers-ranked__header {\n    flex-direction: column;\n    margin-bottom: 24px;\n  }\n\n  .organic-instagram-ranked__control,\n  .organic-followers-ranked__control {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .organic-instagram-ranked__item,\n  .organic-followers-ranked__item {\n    grid-template-columns: 112px minmax(0, 1fr) 62px;\n  }\n\n  .organic-instagram-gender__tooltip {\n    display: none;\n  }\n}\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
